// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:11:33.046Z
// Property: NOVA Lake Norman (ID: 6767906449164260)
// Collections: 28 amenities, 8 floorplans (live), 49 photos, 65 POIs, 5 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449164260",
  "property_external_id": "5441558",
  "property_zillow_url": "https://www.zillow.com/apartments/mooresville-nc/150-west-apartment-homes/5XhwNy/",
  "property_apartments_url": "https://www.apartments.com/nova-lake-norman-mooresville-nc/gm02wdw/",
  "property_google_business_url": "https://www.google.com/maps/place/NOVA+Lake+Norman/data=!4m2!3m1!1s0x0:0x6cb86a23afa8e375?sa=X&ved=2ahUKEwiN2Lj9zbySAxVM4ckDHSG5Cw4Q_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "25816049449",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "nova-lake-norman",
  "property_name": "NOVA Lake Norman",
  "property_website_url": "https://www.novalakenorman.com/",
  "property_domain": "https://www.novalakenorman.com/",
  "property_address": "130 Nile Cir",
  "property_full_address": "130 Nile Cir, Mooresville, NC 28117",
  "property_address_1": "130 Nile Cir",
  "property_address_2": null,
  "property_address_city": "Mooresville",
  "property_address_state": "NC",
  "property_address_zip_full": "28117-8807",
  "property_address_zip": "28117",
  "property_address_country": "US",
  "property_address_county": "Iredell County",
  "property_neighborhood_address": "Outlying Iredell County",
  "property_address_latitude": "35.6026829",
  "property_address_longitude": "-80.9034969",
  "property_email": "novalakenorman@rrliving.com",
  "property_phone": "(704) 662-9065",
  "property_call_tracking_phone": "704-288-4827",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At NOVA Lake Norman in Mooresville, NC, find your ideal haven among our diverse floor plans, including stylish one, two, and three-bedroom apartments. Enjoy features like vaulted ceilings and tranquil pool views, all wrapped in a comfortable community atmosphere. Ready for your next move? Browse availability or schedule a tour today!",
  "property_long_description": "Welcome to NOVA Lake Norman, your ideal destination for modern living in the heart of Mooresville, NC! Discover our diverse array of thoughtfully designed floor plans, featuring one-bedroom, two-bedroom, and three-bedroom apartments that cater to your lifestyle needs. Each unit boasts luxurious amenities, including stunning vaulted ceilings that elevate your living experience, and the convenience of in-unit washer/dryer appliances that simplify your daily routine.\n\nNestled in a vibrant community, many of our apartments offer picturesque pool views, perfect for relaxation after a long day. As a price leader in the market, NOVA Lake Norman provides exceptional value without compromising quality – whether you're lounging by the pool or enjoying the courtyards, your comfort is our priority.\n\nAdditionally, our first-floor units ensure ease of access and come with all the modern features you desire. Ideal for anyone seeking a blend of style, comfort, and convenience, NOVA Lake Norman is more than just a place to live; it’s a community where you can thrive.\n\nFinding your new home has never been easier! Browse our availability today or schedule a tour to visit NOVA Lake Norman and experience firsthand all that our welcoming community has to offer. Don’t miss your chance to bring your living dreams to life!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-afcd-755d-ac40-d3150af5b3ba.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment building and pool area with lounge chairs and umbrellas.",
    "public_id": "019e6466-afcd-755d-ac40-d3150af5b3ba",
    "storage_key": "property/6767906449164260/019e6466-afcd-755d-ac40-d3150af5b3ba.webp",
    "width": 3072,
    "height": 2061
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "201",
  "property_year_built": "1999",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.02487562189054",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs allowed (maximum 2 pets per unit)",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://150westapartments.loftliving.com/login",
  "property_apply_now_url": "https://9166859.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-538c-7299-b233-9b37084a095b.webp",
  "property_primary_logo_media": {
    "alt_text": "Nova Lake Norman logo",
    "public_id": "019e6466-538c-7299-b233-9b37084a095b",
    "storage_key": "property/6767906449164260/019e6466-538c-7299-b233-9b37084a095b.webp",
    "width": 1753,
    "height": 1150
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-5328-7693-8569-38882e09f025.webp",
  "property_secondary_logo_media": {
    "alt_text": "Nova Lake Norman logo",
    "public_id": "019e6466-5328-7693-8569-38882e09f025",
    "storage_key": "property/6767906449164260/019e6466-5328-7693-8569-38882e09f025.webp",
    "width": 1753,
    "height": 1150
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6468-157a-74be-8f45-cb44adefb996.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e6468-157a-74be-8f45-cb44adefb996",
    "storage_key": "property/6767906449164260/019e6468-157a-74be-8f45-cb44adefb996.webp",
    "width": 1280,
    "height": 839
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6468-0a68-748a-a5c8-253bc883ff98.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e6468-0a68-748a-a5c8-253bc883ff98",
    "storage_key": "property/6767906449164260/019e6468-0a68-748a-a5c8-253bc883ff98.webp",
    "width": 1280,
    "height": 839
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#02102d",
  "property_secondary_color": "#c49f5c",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#ffffff",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "420 - 1100",
  "property_sqft_min": "420",
  "property_sqft_max": "1100",
  "property_price_range": "955 - 1495",
  "property_price_min": "955",
  "property_price_max": "1495",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/novalakenormanapartments",
  "property_instagram_url": "https://www.instagram.com/novalakenorman/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJFVpqoGRTUYgRdeOoryNquGw",
  "property_youtube_url": "https://www.youtube.com/shorts/vMFpvM8Vmrw",
  "property_yelp_url": "https://www.yelp.com/biz/150-west-by-rpm-living-mooresville",
  "property_tiktok_url": "https://www.tiktok.com/@novalakenorman",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to NOVA Lake Norman",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "<p>Discover the unbeatable convenience of Mooreville's NOVA Lake Norman, where lakeside living meets affordability—and exciting changes are underway! Our community is currently undergoing extensive renovations throughout the apartment homes and community amenities, all designed to elevate your living experience. Located just one mile from Lake Norman, you'll enjoy easy access to exceptional dining, shopping, and recreation. Our attentive, experienced management and service teams are here to ensure your every need is met. With modern upgrades in progress and a renewed focus on comfort and style, NOVA Lake Norman is the clear choice for your next home. Contact one of our leasing specialists and <a href=\"/contact/\">schedule your tour today</a>!</p>",
  "property_home_floorplans_blurb": "<p>Ideally located in Mooresville, NC, the neighborhood surrounding NOVA Lake Norman has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_home_gallery_blurb": "At NOVA Lake Norman, imagine a lifestyle where comfort meets convenience. Choose from our thoughtfully designed studio to three-bedroom apartments, complete with granite countertops and stainless steel appliances. Enjoy amenities like a refreshing pool, fitness center, and inviting picnic area. Mooresville living at its finest awaits you—picture yourself here!",
  "property_home_neighborhood_blurb": "At NOVA Lake Norman in Mooresville, NC, our vibrant neighborhood invites you to savor local charm. With one, two, and three-bedroom floor plans tailored to your lifestyle, there's a perfect space waiting for you. Uncover delightful nearby favorites and points of interest that make our community truly special.",
  "property_home_reviews_blurb": "At NOVA Lake Norman, our residents appreciate the welcoming atmosphere that surrounds them. With lush Poplar trees and a serene vibe, one resident shares, \"The lovely quiet friendly atmosphere makes me feel refreshed after a long day.\" Come see why so many choose to call our community home!",
  "property_neighborhood_blurb": "<p>Ideally located in Mooresville, NC, the neighborhood surrounding NOVA Lake Norman has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Check out the neighborhood!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At NOVA Lake Norman, we offer a wide range of amenities designed to enhance our residents' lifestyles. Dive into our refreshing swimming pool, enjoy quality moments with your furry friends at our on-site dog park, or stay active at the nearby parks. Plus, we provide convenient on-site laundry facilities and a charming children's playground. Get in touch with our welcoming leasing team today to schedule a personal tour of your potential new residence at NOVA Lake Norman!</p>",
  "property_applynow_blurb": "Experience elevated living at NOVA Lake Norman in Mooresville, NC. Choose from our thoughtfully designed one, two, and three-bedroom floor plans, featuring vaulted ceilings and convenient in-unit washer/dryer. Enjoy serene pool views and exceptional pricing. Ready to make the move? Lease your new home online today!",
  "property_contactus_blurb": "At 150 West Apartment Homes in Mooresville, NC, your ideal living space awaits! With a variety of thoughtfully designed floor plans, finding your perfect home is effortless. Have questions? Our friendly leasing team is just a call away, ready to assist you in starting your next chapter today!",
  "property_faqs_blurb": "At NOVA Lake Norman in Mooresville, NC, our diverse floor plans—ranging from cozy one-bedroom retreats to spacious three-bedroom havens—cater to every lifestyle. Curious about community living? Browse our FAQs page for insights into your future home. Let us guide you to the perfect apartment experience!",
  "property_floorplans_blurb": "<p>Select your dream home from a diverse collection of thoughtfully designed studios, one, two, and three bedroom homes available with us, which includes a variety of conveniences such as fully-equipped kitchens, washer and dryer*, spacious living areas, and more. Enjoy a home that is finished to reflect your unique personal taste.</p>",
  "property_gallery_blurb": "<p>It's all in the details. From the minute you enter you will notice the care and attention to detail all around you. Designed with a sense of community and thoughtful amenities, everything you desire is within your reach. Take a peak at what awaits!</p>",
  "property_interactivemap_blurb": "At NOVA Lake Norman in Mooresville, NC, choose from spacious one, two, or three-bedroom apartments, each featuring vaulted ceilings and stunning pool views. Enjoy the convenience of in-unit washers and dryers. Use our interactive community map to find your perfect fit today! Your new lifestyle awaits.",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At NOVA Lake Norman in Mooresville, NC, our diverse floor plans cater to every lifestyle, whether you need a cozy one-bedroom or a spacious three-bedroom retreat. Invite a friend to join our vibrant community—great friends make great neighbors! Refer a friend today and share the NOVA experience!",
  "property_residentaccess_blurb": "Welcome to NOVA Lake Norman, where spacious one, two, and three-bedroom floor plans cater to your lifestyle in Mooresville, NC. Elevate your living experience by easily managing your home through our resident portal—pay rent, schedule maintenance, and access essential services all in one place!",
  "property_reviews_blurb": "At NOVA Lake Norman, our residents love the welcoming atmosphere and outstanding service. One reviewer highlights, “I have loved my tree top apartment! The lovely, friendly environment makes me feel refreshed after a long day.” Join a community that truly cares and discover your perfect home today!",
  "property_created_at": "1752258130289",
  "property_scheduletour_blurb": "At NOVA Lake Norman in Mooresville, NC, find your perfect retreat with thoughtfully designed one, two, and three-bedroom floor plans. Our vibrant community offers more than just a home; it’s a lifestyle. Ready to see for yourself? Schedule a tour and hear firsthand from our happy residents!",
  "property_thankyou_blurb": "Thank you for your interest in NOVA Lake Norman! Located in Mooresville, NC, our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Keep an eye on your inbox—our team is excited to connect and help you find your ideal home!",
  "property_virtualtours_blurb": "<p>Take a virtual tour of NOVA Lake Norman in Mooresville, NC. Experience our spacious floor plan layouts & modern amenities from the comfort of your home.</p>",
  "property_copyright": "2025 All Rights Reserved. NOVA Lake Norman",
  "property_seo_title_home": "NOVA Lake Norman | Apartments in Mooresville, NC",
  "property_seo_description_home": "Elevate your lifestyle at NOVA Lake Norman! Choose from 1, 2, or 3-bedroom apartments with pool views and modern amenities in Mooresville, NC.",
  "property_seo_title_floorplans": "Find your ideal space at NOVA Lake Norman in Mooresville, NC! Choose from stylish one to three-bedroom floor plans designed for your lifestyle.",
  "property_seo_description_floorplans": "Find your ideal space at NOVA Lake Norman, Mooresville's premier community. Choose from stylish one, two, or three-bedroom floor plans tailored for you!",
  "property_seo_title_amenities": "Amenities | Mooresville, NC Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at NOVA Lake Norman in Mooresville, NC. Enjoy vaulted ceilings, convenient in-home washers, and stunning pool views. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Mooresville, NC",
  "property_seo_description_gallery": "Capture life's moments at NOVA Lake Norman! Dive into our stunning photo gallery showcasing luxe living, vibrant views, and the perfect floor plan for you.",
  "property_seo_title_virtualtours": "Virtual Tours | NOVA Lake Norman Apartments",
  "property_seo_description_virtualtours": "Experience NOVA Lake Norman in Mooresville, NC! Take a virtual tour of our stylish one to three-bedroom apartments and picture your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | NOVA Lake Norman Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at NOVA Lake Norman! Check out our interactive map to unveil one, two, and three-bedroom layouts with stunning amenities in Mooresville, NC.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Mooresville, NC",
  "property_seo_description_neighborhood": "Uncover the charm of Mooresville at NOVA Lake Norman! Check out local favorites and nearby gems while choosing your ideal one, two, or three-bedroom apartment.",
  "property_seo_title_contact": "Contact Us | NOVA Lake Norman",
  "property_seo_description_contact": "\"At 150 West Apartment Homes in Mooresville, NC, your ideal living space awaits! With a variety of thoughtfully designed floor plans tailored to your lifestyle, we're here to help you find your perfect fit. Have questions about our community or availability? Reach out to our friendly leasing team today!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Mooresville, NC",
  "property_seo_description_faqs": "Find answers to your questions about NOVA Lake Norman in Mooresville, NC. Discover our one to three-bedroom floor plans and premium amenities today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Mooresville, NC",
  "property_seo_description_reviews": "Experience life at NOVA Lake Norman in Mooresville, NC. Check out our residents' reviews to see why our one, two, and three-bedroom homes with stunning amenities shine!",
  "property_seo_title_applynow": "Apply Now | Apartments in Mooresville, NC",
  "property_seo_description_applynow": "Experience the charm of NOVA Lake Norman in Mooresville, NC—offering stylish one to three-bedroom apartments with vaulted ceilings and stunning pool views. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | NOVA Lake Norman",
  "property_seo_description_residentaccess": "Access your resident portal at NOVA Lake Norman in Mooresville, NC. Easily pay rent, schedule maintenance, and manage your community life today!",
  "property_seo_title_referafriend": "Refer A Friend | NOVA Lake Norman",
  "property_seo_description_referafriend": "Invite friends to thrive at NOVA Lake Norman! Share the joy of lakeside living in Mooresville—great friends make great neighbors. Refer today!",
  "property_seo_title_scheduletour": "Schedule a Tour | NOVA Lake Norman",
  "property_seo_description_scheduletour": "Experience lakeside living at NOVA Lake Norman! Schedule a tour today and envision your new home in Mooresville's vibrant community.",
  "property_seo_title_privacy": "Privacy Policy | NOVA Lake Norman",
  "property_seo_description_privacy": "Your privacy matters at NOVA Lake Norman. Review our policy to see how we protect your personal information in beautiful Mooresville, NC.",
  "property_seo_title_accessibility": "Website Accessibility | NOVA Lake Norman",
  "property_seo_description_accessibility": "At NOVA Lake Norman, we prioritize digital inclusion for all. Explore our commitment to accessibility in Mooresville, NC, and experience community for everyone!",
  "property_seo_title_sitemap": "Sitemap | NOVA Lake Norman",
  "property_seo_description_sitemap": "Navigate your future at NOVA Lake Norman! Uncover everything our Mooresville community offers. Check out our sitemap for easy access to your new home!",
  "property_seo_title_thankyou": "Thank You | NOVA Lake Norman",
  "property_seo_description_thankyou": "Thank you for reaching out to NOVA Lake Norman! Our team will connect soon to help you find your perfect home in Mooresville, NC. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Mooresville, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293620414",
  "amenities": [
    {
      "id": "custom_b2ebff7e-2b22-46b0-beb1-ea2b4d7279fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Sparkling Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_649e29b6-56e8-4da2-91a3-a7d8a01927d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a18d2a9f-5544-42aa-b2f2-2bbd63517b92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9066a9aa-8319-4a06-8fd3-2313c8b01ba5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Wi‑Fi at Pool and Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49fa4acb-566b-48b0-86d6-4be6749cc73f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50c95220-3293-433b-b651-6d90d5289a95",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c9ea67e9-fa7f-4c04-b83f-de5c1633691a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Community Lobby",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_052b3112-678a-4d38-84cd-c05f151ead48",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ce25263-4f8b-4392-a7e2-8849243ec36e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_908d3552-67bf-4b13-b251-f438661c0f11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95ef39c4-400c-4746-ba06-16025d39da74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Plush Carpet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_12ea949a-52d4-44ab-9461-0e0a696ecdd4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Inspired Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cfb1bd15-68a0-42c3-b801-d2f1466785ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c3d99f97-2387-4c07-8a03-71c25947e215",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d76b87b-c0d0-4e8f-ae48-435b70fed1e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Private Decks or Patios",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4fb40472-76c9-41a2-bed0-21053b7740f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Open-Concept Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c7ae62d-831f-4834-9bb4-9374b87947a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02ec26c3-9b00-490c-9912-99d2f8bcd8f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Pet-Friendly",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4cf4aa9d-9202-482a-8f76-83668b85654a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Cornhole",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_47e19f99-6aec-4afd-af06-d9bc1fcb9b81",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Firepit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_35cef0a6-0841-47ad-9ebd-77ecc22542a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Door to Door Trash Pick-up",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a5cfe369-ebf7-4182-aeb4-0d9439478fe9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c5efaf2e-c23d-4fcc-8276-891f01c2556d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "*Private Wooded Views",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc44a59f-a4fb-4447-b3df-2d19dfc2c90a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Shuffleboard",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f7d8704-f19f-494d-85ec-df7c837460c2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Grill Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f59fb882-43d3-449a-904b-9c5e6bf75203",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "*Washer/Dryer Hook Ups",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dbae7a33-fef7-48cb-86c2-f0d35d486719",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "*Washer/Dryer In-Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e8d1598-c06e-455c-a96b-0f47f80e385e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "external_id": "false",
      "title": "*Kitchen Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_358f68cd-3ead-495f-8667-8b38dad686e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-afcd-755d-ac40-d3150af5b3ba.webp",
      "image_media": {
        "alt_text": "Apartment building and pool area with lounge chairs and umbrellas.",
        "public_id": "019e6466-afcd-755d-ac40-d3150af5b3ba",
        "storage_key": "property/6767906449164260/019e6466-afcd-755d-ac40-d3150af5b3ba.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the pool or relax on a lounge chair in this beautiful outdoor community space.",
      "link": "",
      "alt_text": "Apartment building and pool area with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1cf11a7d-f109-4de3-8656-b34555f40623",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e95f5-0dfd-72bb-866a-144d781547f1.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station and pool area with lounge chairs and fire pit.",
        "public_id": "019e95f5-0dfd-72bb-866a-144d781547f1",
        "storage_key": "property/6767906449164260/019e95f5-0dfd-72bb-866a-144d781547f1.webp",
        "width": 1500,
        "height": 1003
      },
      "title": "Community",
      "description": "Enjoy outdoor living with a built-in grill, sparkling pool, comfortable lounge chairs, and a cozy fire pit area.",
      "link": "",
      "alt_text": "Outdoor grilling station and pool area with lounge chairs and fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e734fe90-fd72-4d61-8fb3-f3c1cd141e34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e95f5-0a00-75e1-871c-f40713bb58ed.webp",
      "image_media": {
        "alt_text": "Modern living room with a sofa, coffee table, and open-concept kitchen.",
        "public_id": "019e95f5-0a00-75e1-871c-f40713bb58ed",
        "storage_key": "property/6767906449164260/019e95f5-0a00-75e1-871c-f40713bb58ed.webp",
        "width": 1500,
        "height": 1003
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, a glass coffee table, and a view into the modern open-concept kitchen with bar seating.",
      "link": "",
      "alt_text": "Modern living room with a sofa, coffee table, and open-concept kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f703eb4-19da-4ba2-8ede-da992cc2ddb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-5095-72cb-b494-7e954d13109e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e6466-5095-72cb-b494-7e954d13109e",
        "storage_key": "property/6767906449164260/019e6466-5095-72cb-b494-7e954d13109e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample white cabinetry, and elegant granite countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fc57842f-9063-4098-bf62-0ee58cd7d298",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e95f5-09f2-763a-bbe1-e5dbef0f3836.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, ceiling fan, and window.",
        "public_id": "019e95f5-09f2-763a-bbe1-e5dbef0f3836",
        "storage_key": "property/6767906449164260/019e95f5-09f2-763a-bbe1-e5dbef0f3836.webp",
        "width": 1500,
        "height": 1003
      },
      "title": "Apartment",
      "description": "Cozy and inviting bedroom featuring a comfortable bed, ceiling fan, and ample natural light from the window. Perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a bed, ceiling fan, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c70f85cb-9c00-45b9-8f33-fcc68bade873",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e95f5-09f4-76ba-b74c-249e798020e3.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, plush pillows, and a ceiling fan.",
        "public_id": "019e95f5-09f4-76ba-b74c-249e798020e3",
        "storage_key": "property/6767906449164260/019e95f5-09f4-76ba-b74c-249e798020e3.webp",
        "width": 1500,
        "height": 1003
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, vibrant accent pillows, and a sleek ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, plush pillows, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7fdc20cc-e3e1-4450-b99a-921cbb37388b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e95f5-0a34-75ed-a78c-91e4bb00a16f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a breakfast bar with seating.",
        "public_id": "019e95f5-0a34-75ed-a78c-91e4bb00a16f",
        "storage_key": "property/6767906449164260/019e95f5-0a34-75ed-a78c-91e4bb00a16f.webp",
        "width": 1500,
        "height": 1003
      },
      "title": "Apartment",
      "description": "A stylish kitchen featuring a breakfast bar with comfortable seating, sleek white cabinetry, granite countertops, and modern stainless steel appliances. Perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a breakfast bar with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_defdfb67-f1f3-4fff-aa33-16b03e6f95e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-74a7-733b-9873-3f8227fb1f61.webp",
      "image_media": {
        "alt_text": "Outdoor courtyard with lounge chairs, tables, umbrellas, and cornhole boards in front of apartment buildings.",
        "public_id": "019e6466-74a7-733b-9873-3f8227fb1f61",
        "storage_key": "property/6767906449164260/019e6466-74a7-733b-9873-3f8227fb1f61.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Community",
      "description": "Enjoy our beautiful outdoor courtyard, complete with comfortable lounge chairs, tables, umbrellas, and fun games like cornhole, perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Outdoor courtyard with lounge chairs, tables, umbrellas, and cornhole boards in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ba40fe53-4787-484a-977b-6bbe2dbf751f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-af08-7065-aef0-e5d8ad621a82.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e6466-af08-7065-aef0-e5d8ad621a82",
        "storage_key": "property/6767906449164260/019e6466-af08-7065-aef0-e5d8ad621a82.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautifully appointed kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c37f8cd-430f-4c61-9356-0884f6e6b13e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-9544-75ae-9b5c-ceaad015b56a.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment with light gray walls, wood-look flooring, and white cabinets.",
        "public_id": "019e6466-9544-75ae-9b5c-ceaad015b56a",
        "storage_key": "property/6767906449164260/019e6466-9544-75ae-9b5c-ceaad015b56a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area seamlessly transitions into a modern kitchen, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area in an apartment with light gray walls, wood-look flooring, and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c5025eff-fb60-41cd-9911-54001c736e93",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-d4c4-7079-9cc7-d5e644940f93.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets and stainless steel appliances.",
        "public_id": "019e6466-d4c4-7079-9cc7-d5e644940f93",
        "storage_key": "property/6767906449164260/019e6466-d4c4-7079-9cc7-d5e644940f93.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring white cabinetry, granite countertops, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2c320f57-73e1-4873-8829-0a7c8f9b0a7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e95f5-0dc8-75b1-a23c-249bfc0309b0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertop and stainless steel appliances.",
        "public_id": "019e95f5-0dc8-75b1-a23c-249bfc0309b0",
        "storage_key": "property/6767906449164260/019e95f5-0dc8-75b1-a23c-249bfc0309b0.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Beautifully updated kitchen featuring a granite island, sleek cabinetry, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertop and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_149c4ece-6876-4439-86ca-d826588eb42f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-6590-75aa-81c2-9f7dcad0a410.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a fire pit area.",
        "public_id": "019e6466-6590-75aa-81c2-9f7dcad0a410",
        "storage_key": "property/6767906449164260/019e6466-6590-75aa-81c2-9f7dcad0a410.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling pool, relax on the sun deck, or gather around the fire pit for a cozy evening under the stars.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a fire pit area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bada73e0-0f74-44d7-b5b1-f5df9884b30b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-9efb-771a-b7a3-92effc2faa5e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment with wood-look flooring and a ceiling fan.",
        "public_id": "019e6466-9efb-771a-b7a3-92effc2faa5e",
        "storage_key": "property/6767906449164260/019e6466-9efb-771a-b7a3-92effc2faa5e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room adjacent to a modern kitchen featuring white cabinetry and stainless steel appliances. Perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area in an apartment with wood-look flooring and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5b8eb802-8718-4795-a3d3-79205cf9fbe5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-cf93-77b4-bece-1ced272f8e0d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, black faucet, and white bathtub/shower combo.",
        "public_id": "019e6466-cf93-77b4-bece-1ced272f8e0d",
        "storage_key": "property/6767906449164260/019e6466-cf93-77b4-bece-1ced272f8e0d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a clean and updated bathroom featuring a spacious vanity, modern fixtures, and a convenient bathtub/shower combination.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, black faucet, and white bathtub/shower combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_705057b6-9f5d-4567-8e31-2a0bee120f66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-cc29-71dc-a541-c493b6423af3.webp",
      "image_media": {
        "alt_text": "Interior view of a bedroom with double doors and a glimpse of the kitchen through an open doorway.",
        "public_id": "019e6466-cc29-71dc-a541-c493b6423af3",
        "storage_key": "property/6767906449164260/019e6466-cc29-71dc-a541-c493b6423af3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, neutral grey walls, and wood-look flooring. Double doors lead to a closet, and an open doorway reveals a modern white kitchen.",
      "link": "",
      "alt_text": "Interior view of a bedroom with double doors and a glimpse of the kitchen through an open doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be4d8632-f00f-4553-9179-10c4083d76bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-d258-7158-bfcd-98cb0d286854.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with ceiling fan and granite countertops",
        "public_id": "019e6466-d258-7158-bfcd-98cb0d286854",
        "storage_key": "property/6767906449164260/019e6466-d258-7158-bfcd-98cb0d286854.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area that flows into the kitchen, featuring a ceiling fan and modern granite countertops.",
      "link": "",
      "alt_text": "Living room and kitchen area with ceiling fan and granite countertops",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_54e773ee-aaab-4ed6-bccd-d750921ff4cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-d7d4-7067-b9c9-2b4fc77c309e.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with wood-look flooring, ceiling fan, and window.",
        "public_id": "019e6466-d7d4-7067-b9c9-2b4fc77c309e",
        "storage_key": "property/6767906449164260/019e6466-d7d4-7067-b9c9-2b4fc77c309e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and bright living area in an apartment, featuring modern wood-look flooring, a ceiling fan, and a large window with blinds.",
      "link": "",
      "alt_text": "Empty apartment living room with wood-look flooring, ceiling fan, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1322211d-8105-4ef4-80ac-b37ebef6b41b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-9fd0-7388-88a3-f312508839c0.webp",
      "image_media": {
        "alt_text": "Interior view of a bedroom with double closet doors.",
        "public_id": "019e6466-9fd0-7388-88a3-f312508839c0",
        "storage_key": "property/6767906449164260/019e6466-9fd0-7388-88a3-f312508839c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring sleek double doors leading to a large closet, offering ample storage and a clean, modern aesthetic.",
      "link": "",
      "alt_text": "Interior view of a bedroom with double closet doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1cb4a0ba-4786-45d6-a9eb-16647e5c6508",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-c0ee-75c8-bffc-dc7598c5057e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a granite countertop.",
        "public_id": "019e6466-c0ee-75c8-bffc-dc7598c5057e",
        "storage_key": "property/6767906449164260/019e6466-c0ee-75c8-bffc-dc7598c5057e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish kitchen featuring stainless steel appliances, ample cabinet storage, and a beautiful granite countertop. Perfect for preparing meals and entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a granite countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c0fa663-37eb-4499-a932-cb37161df586",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-af07-7268-9663-0df844e125ab.webp",
      "image_media": {
        "alt_text": "Empty living room with wood-look flooring, a ceiling fan, a white door, and a window with blinds.",
        "public_id": "019e6466-af07-7268-9663-0df844e125ab",
        "storage_key": "property/6767906449164260/019e6466-af07-7268-9663-0df844e125ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this bright and airy living space featuring modern wood-look flooring and a ceiling fan for comfort. The large window floods the room with natural light.",
      "link": "",
      "alt_text": "Empty living room with wood-look flooring, a ceiling fan, a white door, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a46bf4ff-0124-4313-aad0-771c2340144b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-9a5a-75c8-9b5a-b36f150e8ecb.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, black faucet, and a beige shower curtain.",
        "public_id": "019e6466-9a5a-75c8-9b5a-b36f150e8ecb",
        "storage_key": "property/6767906449164260/019e6466-9a5a-75c8-9b5a-b36f150e8ecb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this clean and updated bathroom, featuring a spacious vanity with modern fixtures and a calming beige shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, black faucet, and a beige shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fc7bc529-5f7e-4261-aa5d-3cfd7a6c36c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-943d-72d9-a66b-59bca9ab1767.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinets.",
        "public_id": "019e6466-943d-72d9-a66b-59bca9ab1767",
        "storage_key": "property/6767906449164260/019e6466-943d-72d9-a66b-59bca9ab1767.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring sleek stainless steel appliances, durable granite countertops, and ample white cabinetry for all your storage needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d17ce7a-b4ef-4f84-9b68-53b5fe6fb62b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-b11e-743a-a6e9-1f02808a9ea5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e6466-b11e-743a-a6e9-1f02808a9ea5",
        "storage_key": "property/6767906449164260/019e6466-b11e-743a-a6e9-1f02808a9ea5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a beautifully designed kitchen featuring ample cabinet space, sleek granite countertops, and modern stainless steel appliances. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_312d0b7f-ecb3-42a0-b23f-08f53f40b43a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e95f5-0e12-70bf-aab3-48344beefb1e.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019e95f5-0e12-70bf-aab3-48344beefb1e",
        "storage_key": "property/6767906449164260/019e95f5-0e12-70bf-aab3-48344beefb1e.webp",
        "width": 1500,
        "height": 1002
      },
      "title": "Community",
      "description": "Enjoy the refreshing outdoor swimming pool, perfect for relaxation and fun, surrounded by comfortable lounge chairs and umbrellas. A beautiful community amenity for residents.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_41d89e7e-2d89-42b5-9433-e65028bb4702",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-93d9-759b-b9b0-332d8223fa79.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan, double closet doors, and view into a bathroom.",
        "public_id": "019e6466-93d9-759b-b9b0-332d8223fa79",
        "storage_key": "property/6767906449164260/019e6466-93d9-759b-b9b0-332d8223fa79.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, ample closet space, and convenient access to a well-appointed bathroom.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan, double closet doors, and view into a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f46dcbfe-71ed-4eb1-afe6-7d81a65f92a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-90aa-70af-89a6-f22ad2017e51.webp",
      "image_media": {
        "alt_text": "Open concept living area with kitchen and dining bar.",
        "public_id": "019e6466-90aa-70af-89a6-f22ad2017e51",
        "storage_key": "property/6767906449164260/019e6466-90aa-70af-89a6-f22ad2017e51.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with a dining bar, perfect for entertaining.",
      "link": "",
      "alt_text": "Open concept living area with kitchen and dining bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1900a71-41cf-475f-a5b6-c4fcca2f4975",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e95f5-0da3-75d8-9026-97e293543c07.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019e95f5-0da3-75d8-9026-97e293543c07",
        "storage_key": "property/6767906449164260/019e95f5-0da3-75d8-9026-97e293543c07.webp",
        "width": 1500,
        "height": 1003
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, granite countertops, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ff1b852c-a048-4938-8b89-1af679d3b784",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-90a6-7474-b6cb-e49053e5afad.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e6466-90a6-7474-b6cb-e49053e5afad",
        "storage_key": "property/6767906449164260/019e6466-90a6-7474-b6cb-e49053e5afad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring stainless steel appliances, ample cabinet storage, and elegant granite countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_044c4fba-d45b-469a-aefd-4cb9227dc09d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-572c-7214-9ddb-6daef1452db3.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool with lounge chairs and umbrellas.",
        "public_id": "019e6466-572c-7214-9ddb-6daef1452db3",
        "storage_key": "property/6767906449164260/019e6466-572c-7214-9ddb-6daef1452db3.webp",
        "width": 3072,
        "height": 2061
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and shaded areas.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f3567dbd-ed82-4653-9c53-012803b232d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-8502-733c-a104-217f86312845.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, shower, toilet, and vanity with a sink and mirror.",
        "public_id": "019e6466-8502-733c-a104-217f86312845",
        "storage_key": "property/6767906449164260/019e6466-8502-733c-a104-217f86312845.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort with this modern bathroom, featuring a pristine white bathtub and shower combo, a sleek vanity with a basin sink, and a large mirror. Enjoy a clean and refreshing space.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, shower, toilet, and vanity with a sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1fb54a3-5ca5-4715-901f-8e5db76fb487",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-7f9f-74ab-a0bb-9daf10fdc236.webp",
      "image_media": {
        "alt_text": "Open-concept living area and kitchen with a kitchen island, white cabinets, and a ceiling fan.",
        "public_id": "019e6466-7f9f-74ab-a0bb-9daf10fdc236",
        "storage_key": "property/6767906449164260/019e6466-7f9f-74ab-a0bb-9daf10fdc236.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area and kitchen, featuring a modern kitchen island, sleek white cabinetry, and elegant wood-look flooring.",
      "link": "",
      "alt_text": "Open-concept living area and kitchen with a kitchen island, white cabinets, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eea9be88-50db-4834-83ee-650b3abf3e12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-7ec5-748f-8634-8415dcc2022b.webp",
      "image_media": {
        "alt_text": "Interior of a bedroom with double doors leading to a closet.",
        "public_id": "019e6466-7ec5-748f-8634-8415dcc2022b",
        "storage_key": "property/6767906449164260/019e6466-7ec5-748f-8634-8415dcc2022b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring double doors that open to ample closet space, complemented by neutral-toned walls and wood-look flooring.",
      "link": "",
      "alt_text": "Interior of a bedroom with double doors leading to a closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8d1d25f2-a31d-4b20-8eca-bdd221c32691",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-786c-7288-8592-046248a22e9a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e6466-786c-7288-8592-046248a22e9a",
        "storage_key": "property/6767906449164260/019e6466-786c-7288-8592-046248a22e9a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops. Perfect for home chefs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_baeedb12-20e6-47b7-a339-c66704108e39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-7766-73ff-8f35-042cc9655e68.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and ensuite bathroom",
        "public_id": "019e6466-7766-73ff-8f35-042cc9655e68",
        "storage_key": "property/6767906449164260/019e6466-7766-73ff-8f35-042cc9655e68.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, ample closet space, and a private ensuite bathroom.",
      "link": "",
      "alt_text": "Bedroom with closet and ensuite bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9376cf35-49fe-4f29-9ca6-ad637d182a78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e95f5-0a24-72e2-b667-e958dd2bf47c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, black faucet, toilet, and shower with curtain.",
        "public_id": "019e95f5-0a24-72e2-b667-e958dd2bf47c",
        "storage_key": "property/6767906449164260/019e95f5-0a24-72e2-b667-e958dd2bf47c.webp",
        "width": 1500,
        "height": 1003
      },
      "title": "Apartment",
      "description": "Spacious and clean bathroom featuring a white vanity, a modern black faucet, a toilet, and a shower with a white curtain. This bathroom offers a fresh and contemporary feel.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, black faucet, toilet, and shower with curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_694b63d4-33bb-4da9-b472-a27e977ac16d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-767c-77ee-ad51-4fdde47c8b1e.webp",
      "image_media": {
        "alt_text": "Empty living area with a ceiling fan, front door, and window with blinds.",
        "public_id": "019e6466-767c-77ee-ad51-4fdde47c8b1e",
        "storage_key": "property/6767906449164260/019e6466-767c-77ee-ad51-4fdde47c8b1e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into this bright and airy living space featuring a ceiling fan, a convenient front door, and a large window that lets in natural light.",
      "link": "",
      "alt_text": "Empty living area with a ceiling fan, front door, and window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a83e12b2-8df8-4a7b-b2da-c77b4064ad12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e95f5-0e07-77d8-bf71-d27f3482b029.webp",
      "image_media": {
        "alt_text": "Apartment complex with an outdoor swimming pool, lounge chairs, and tables under umbrellas.",
        "public_id": "019e95f5-0e07-77d8-bf71-d27f3482b029",
        "storage_key": "property/6767906449164260/019e95f5-0e07-77d8-bf71-d27f3482b029.webp",
        "width": 1500,
        "height": 1003
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge areas and shaded seating, perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Apartment complex with an outdoor swimming pool, lounge chairs, and tables under umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d1c25f4-1954-4582-830b-23bd3cb18062",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-6d18-747b-8d60-a9b388351760.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment unit showing the entrance door, a ceiling fan, and a window with blinds.",
        "public_id": "019e6466-6d18-747b-8d60-a9b388351760",
        "storage_key": "property/6767906449164260/019e6466-6d18-747b-8d60-a9b388351760.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into a bright and airy apartment unit. This space features a ceiling fan for comfort, a welcoming entrance door, and a large window with blinds allowing natural light to fill the room.",
      "link": "",
      "alt_text": "Interior view of an apartment unit showing the entrance door, a ceiling fan, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7fa63fc6-5323-4bf2-a204-d9584c107ee4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-7211-775e-8821-2a8d8062c91d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and wood-look flooring.",
        "public_id": "019e6466-7211-775e-8821-2a8d8062c91d",
        "storage_key": "property/6767906449164260/019e6466-7211-775e-8821-2a8d8062c91d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience style and convenience in our modern kitchens, featuring sleek white cabinetry, granite countertops, and stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c272812d-dbd9-4046-8fb9-889154ec44b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-6b55-7658-bf18-553125e67c0c.webp",
      "image_media": {
        "alt_text": "View of a bedroom with light grey walls, a ceiling fan, and a closet with double doors.",
        "public_id": "019e6466-6b55-7658-bf18-553125e67c0c",
        "storage_key": "property/6767906449164260/019e6466-6b55-7658-bf18-553125e67c0c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into this inviting bedroom, featuring a soothing light grey palette and a convenient closet. The adjacent view offers a glimpse of the modern kitchen.",
      "link": "",
      "alt_text": "View of a bedroom with light grey walls, a ceiling fan, and a closet with double doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_97830fac-006f-4267-92c0-e838c4e6811d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-677f-7359-8ba4-a348eacf0326.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a dishwasher.",
        "public_id": "019e6466-677f-7359-8ba4-a348eacf0326",
        "storage_key": "property/6767906449164260/019e6466-677f-7359-8ba4-a348eacf0326.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience a stylish and functional kitchen featuring white shaker cabinets, elegant granite countertops, and a full suite of stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c3adf996-e78f-4907-a1d6-51c7d818097f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-6236-754a-9d53-bc4e7100f102.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019e6466-6236-754a-9d53-bc4e7100f102",
        "storage_key": "property/6767906449164260/019e6466-6236-754a-9d53-bc4e7100f102.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "This apartment features a stylish kitchen with sleek white cabinetry, elegant granite countertops, and a full suite of modern stainless steel appliances, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2cccb3fb-c45b-4f28-9188-949b73d3d9a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-64bb-7429-a88f-371f87d77eb6.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, faucet, toilet, and bathtub with shower.",
        "public_id": "019e6466-64bb-7429-a88f-371f87d77eb6",
        "storage_key": "property/6767906449164260/019e6466-64bb-7429-a88f-371f87d77eb6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into this clean and updated bathroom featuring a spacious vanity, sleek fixtures, and a relaxing bathtub/shower combo. Perfect for unwinding.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, sink, faucet, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8f2c9f1d-549d-44f8-8835-0ef4a5f0b200",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-5405-778a-908f-9bbd6edcfcad.webp",
      "image_media": {
        "alt_text": "Open living area with a kitchen view, featuring gray walls and wood-look flooring.",
        "public_id": "019e6466-5405-778a-908f-9bbd6edcfcad",
        "storage_key": "property/6767906449164260/019e6466-5405-778a-908f-9bbd6edcfcad.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area with a modern kitchen, perfect for entertaining. Enjoy the bright and airy feel of this apartment home.",
      "link": "",
      "alt_text": "Open living area with a kitchen view, featuring gray walls and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_109c821c-d257-498b-8fb9-2ce948450e83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-4ef2-700c-9573-d7986f007c65.webp",
      "image_media": {
        "alt_text": "Empty living room with view of kitchen and doorway to another room.",
        "public_id": "019e6466-4ef2-700c-9573-d7986f007c65",
        "storage_key": "property/6767906449164260/019e6466-4ef2-700c-9573-d7986f007c65.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living room with a ceiling fan, open to a modern kitchen with stainless steel appliances. Access to another room via a doorway.",
      "link": "",
      "alt_text": "Empty living room with view of kitchen and doorway to another room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d5ede2be-ab97-41d5-b9a1-098999ff9f96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-5220-75fb-8c97-e291f468cb7b.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a ceiling fan and island.",
        "public_id": "019e6466-5220-75fb-8c97-e291f468cb7b",
        "storage_key": "property/6767906449164260/019e6466-5220-75fb-8c97-e291f468cb7b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern living room and open-concept kitchen featuring a ceiling fan, kitchen island with a sink, and new appliances.",
      "link": "",
      "alt_text": "Living room and kitchen area with a ceiling fan and island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94e70ff6-ff39-4a6c-857e-a9ab9a2a7a19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-4e6c-7770-828c-bd762a0c2c44.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and shower/tub combo.",
        "public_id": "019e6466-4e6c-7770-828c-bd762a0c2c44",
        "storage_key": "property/6767906449164260/019e6466-4e6c-7770-828c-bd762a0c2c44.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Step into this modern bathroom featuring a clean vanity with a sleek faucet, a convenient toilet, and a classic shower and tub combination.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b65a3f23-8274-4e80-816c-35078394c230",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e6466-735d-74de-af16-fd0a8d3aff34.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets and stainless steel appliances.",
        "public_id": "019e6466-735d-74de-af16-fd0a8d3aff34",
        "storage_key": "property/6767906449164260/019e6466-735d-74de-af16-fd0a8d3aff34.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white cabinetry, granite countertops, stainless steel appliances including a refrigerator, microwave, and stove.",
      "link": "",
      "alt_text": "Kitchen with white cabinets and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_321ec532-c90c-4ba4-a443-72f456eba8b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Eddie's on Lake Norman",
      "poi_type": "Restaurants",
      "poi_address": "643 Williamson Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "Casual restaurant and bar offering Italian dishes, seafood, and a popular patio.",
      "poi_long_description": "Diners say this restaurant serves up delicious fried oysters, fish and chips, crab cakes, and mahi mahi. They also highlight the lively atmosphere with live music, patio seating, and beautiful lake views.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-24e2-73fc-b891-b3da2a53ea35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-24e2-73fc-b891-b3da2a53ea35",
        "storage_key": "property/6767906449164260/019d0812-24e2-73fc-b891-b3da2a53ea35.webp",
        "width": 1280,
        "height": 672
      },
      "poi_business_url": "http://eddieslkn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16223426483981912417",
      "poi_item_slug": "eddies-on-lake-norman",
      "poi_latitude": "35.5669393",
      "poi_longitude": "-80.8657309",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-799-2090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6ed9-704e-9a92-376db3942157",
        "storage_key": "property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD37noTKrVogRYQloiW4wJeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0c696e03-777e-4236-8a3b-884e040ef0c0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "The Barcelona Burger And Beer Garden",
      "poi_type": "Restaurants",
      "poi_address": "500 S Main St, Mooresville, NC 28115, USA",
      "poi_short_description": "Casual eatery known for its burgers, also offering rotisserie chicken, beer on tap, and outdoor seating.",
      "poi_long_description": "Diners say this hamburger restaurant serves up delicious smash burgers, truffle fries, and rotisserie chicken, and they praise the fresh ingredients and quick service. They also highlight the friendly staff, family-friendly atmosphere, and outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-272d-758b-bb1d-200254adbc63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-272d-758b-bb1d-200254adbc63",
        "storage_key": "property/6767906449164260/019d0812-272d-758b-bb1d-200254adbc63.webp",
        "width": 1280,
        "height": 1082
      },
      "poi_business_url": "http://www.barcelonaburger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4001059951961338295",
      "poi_item_slug": "the-barcelona-burger-and-beer-garden",
      "poi_latitude": "35.5762029",
      "poi_longitude": "-80.8193967",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6ed9-704e-9a92-376db3942157",
        "storage_key": "property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-5zGn1pVUYgRt3Gy6dOehjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_b7a17002-051b-401d-845f-3070ce909003",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Rio 150 Mexican Restaurant - River Hwy",
      "poi_type": "Restaurants",
      "poi_address": "482 River Hwy, Mooresville, NC 28117, USA",
      "poi_short_description": "Family-run Mexican restaurant known for traditional cuisine and giant margaritas.",
      "poi_long_description": "Diners say this Mexican restaurant serves up delicious margaritas, fajitas, and burritos. They also highlight the friendly and attentive staff, reasonable prices, and authentic Mexican flavors.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-271e-7129-87e7-2c5b0b1513f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-271e-7129-87e7-2c5b0b1513f5",
        "storage_key": "property/6767906449164260/019d0812-271e-7129-87e7-2c5b0b1513f5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://rio150.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2851577001028083689",
      "poi_item_slug": "rio-150-mexican-restaurant---river-hwy",
      "poi_latitude": "35.5959323",
      "poi_longitude": "-80.86414830000001",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-660-0262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6ed9-704e-9a92-376db3942157",
        "storage_key": "property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTTtH5-VUUYgR6d_zkyzWkic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_dd86cd20-9a8a-4da4-aa34-300c0bb662d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "457 River Hwy, Mooresville, NC 28117, USA",
      "poi_short_description": "Fast-food chain known for chicken sandwiches and other chicken dishes, along with breakfast and salads.",
      "poi_long_description": "Diners say this chicken restaurant offers delicious chicken sandwiches, waffle fries, and a variety of other tasty options. They also highlight the friendly and helpful staff, fast service, and clean dining area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-274a-749a-825e-17f4d44cc4ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-274a-749a-825e-17f4d44cc4ff",
        "storage_key": "property/6767906449164260/019d0812-274a-749a-825e-17f4d44cc4ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/nc/mooresville?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=14442450834067953335",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.5936863",
      "poi_longitude": "-80.8623732",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-799-0401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6ed9-704e-9a92-376db3942157",
        "storage_key": "property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_myFuZUUYgRtxaqooPkbcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_eb3acfb1-38ba-44d1-a74c-efe44509d289",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Bae's Burgers",
      "poi_type": "Restaurants",
      "poi_address": "246 N Main St, Mooresville, NC 28115, USA",
      "poi_short_description": "Laid-back spot serving classic burgers and other comfort eats such as garlic parm fries.",
      "poi_long_description": "Diners say this hamburger restaurant serves up delicious smash burgers, especially the Bae's burger and GBB (Garlic Butter Burger), alongside tasty garlic parm fries and a variety of sauces, including Bae sauce and garlic aioli. They also highlight the friendly and efficient service, and the clean and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-2db1-73a8-8ec5-63e632074b9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-2db1-73a8-8ec5-63e632074b9f",
        "storage_key": "property/6767906449164260/019d0812-2db1-73a8-8ec5-63e632074b9f.webp",
        "width": 1253,
        "height": 1280
      },
      "poi_business_url": "https://www.baesburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4589049687407512915",
      "poi_item_slug": "baes-burgers",
      "poi_latitude": "35.5842358",
      "poi_longitude": "-80.81064250000001",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 980-944-8606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6ed9-704e-9a92-376db3942157",
        "storage_key": "property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy_JsPXtZUYgRU82KemCUrz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_16a33333-9dd4-41bd-b8f3-1e699f463f65",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "509 River Hwy, Mooresville, NC 28117, USA",
      "poi_short_description": "Home improvement store providing tools, appliances, and building materials, as well as installation and assembly services.",
      "poi_long_description": "People say this home improvement store has helpful staff and a wide selection of products, including electrical materials. They also highlight the friendly and efficient customer service, with many reviewers mentioning specific positive experiences.\n\nSome reviews mention the wait times for assistance can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-2fe4-75ed-95b3-40ab186d4fa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-2fe4-75ed-95b3-40ab186d4fa4",
        "storage_key": "property/6767906449164260/019d0812-2fe4-75ed-95b3-40ab186d4fa4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lowes.com/store/NC-Mooresville/0595?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-595-_-na-_-0-_-0&y_source=1_MTE4MzgzNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17568139753596201438",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.5928972",
      "poi_longitude": "-80.866276",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-660-7177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-14ae8055c241.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-14ae8055c241",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-14ae8055c241.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0y7EYuhUUYgR3imFoQaSzvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_f54c475a-fef2-4aff-a7e3-526666d2532b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Publix Super Market at Brawley Commons",
      "poi_type": "Shopping & Retail",
      "poi_address": "631 Brawley School Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "Chain grocery outpost with a deli, bakery, and florist, along with high-quality meats, and seafood.",
      "poi_long_description": "Shoppers say this supermarket offers delicious fried chicken from the deli, a great selection of subs, and a well-stocked pharmacy. They also highlight the friendly and helpful staff, and the clean and well-organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-2e8f-7555-bbac-e0d0f594c623.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-2e8f-7555-bbac-e0d0f594c623",
        "storage_key": "property/6767906449164260/019d0812-2e8f-7555-bbac-e0d0f594c623.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1519&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=4649156261427803829",
      "poi_item_slug": "publix-super-market-at-brawley-commons",
      "poi_latitude": "35.5816532",
      "poi_longitude": "-80.8748841",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-660-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-23b200cd596f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-23b200cd596f",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-23b200cd596f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7VsvsdUUYgRtfavy_wehUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_5f59e15b-ae06-4b8a-92d9-f6b8b7faabaf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Publix Super Market at The Village Shoppes",
      "poi_type": "Shopping & Retail",
      "poi_address": "7883 Village Center N, Sherrills Ford, NC 28673, USA",
      "poi_short_description": "Supermarket chain for groceries, including baked goods, deli items, and meats, plus prepared foods.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-346c-7637-9d0e-a3248e42a3c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-346c-7637-9d0e-a3248e42a3c6",
        "storage_key": "property/6767906449164260/019d0812-346c-7637-9d0e-a3248e42a3c6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1583&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=9973978544245023170",
      "poi_item_slug": "publix-super-market-at-the-village-shoppes",
      "poi_latitude": "35.5848284",
      "poi_longitude": "-80.9892007",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 828-478-2644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-23b200cd596f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-23b200cd596f",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-23b200cd596f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmf6CJlRNUYgRwqEXP6Swaoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_70b38a7e-211f-4541-9ef0-278fba9f276a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Lowes Foods of Mooresville",
      "poi_type": "Shopping & Retail",
      "poi_address": "125 Center Square Dr, Mooresville, NC 28117, USA",
      "poi_short_description": "Chain grocery store providing a deli, smokehouse, bakery, and salad bar, as well as beer on tap.",
      "poi_long_description": "Shoppers say this grocery store offers a great selection of bakery items, a delicious salad bar, and a diverse wine selection. They also highlight the friendly and helpful staff, and the clean and well-organized store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-34ca-7309-b3b3-8506d01d47dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-34ca-7309-b3b3-8506d01d47dc",
        "storage_key": "property/6767906449164260/019d0812-34ca-7309-b3b3-8506d01d47dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lowesfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10893724348891545491",
      "poi_item_slug": "lowes-foods-of-mooresville",
      "poi_latitude": "35.587591",
      "poi_longitude": "-80.872384",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-660-9594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-23b200cd596f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-23b200cd596f",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-23b200cd596f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ--Cyj8NUUYgRkz-08JNILpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1a6a96ab-9db5-4d20-a9e6-4ff4f1d2ef1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Mooresville Public Library",
      "poi_type": "Education",
      "poi_address": "304 S Main St, Mooresville, NC 28115, USA",
      "poi_short_description": "Public library with a large collection of books and DVDs, plus self-service checkout kiosks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-34f2-7341-a1ef-175af44d76b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-34f2-7341-a1ef-175af44d76b4",
        "storage_key": "property/6767906449164260/019d0812-34f2-7341-a1ef-175af44d76b4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mooresvillelibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10431103371464966759",
      "poi_item_slug": "mooresville-public-library",
      "poi_latitude": "35.579234",
      "poi_longitude": "-80.81626",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-664-2927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-18b06b8da46c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-18b06b8da46c",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-18b06b8da46c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj3pIwVtVUYgRZ4KM_z-5wpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_58d700b1-9a53-4128-a274-1b4bafee24e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "North Carolina Auto Racing Hall of Fame",
      "poi_type": "Entertainment",
      "poi_address": "119 Knob Hill Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "Exhibits dedicated to the history of auto racing, including stock cars, IndyCar, and drag racing, plus a gift shop.",
      "poi_long_description": "Visitors say this museum features a collection of race cars and memorabilia, with a well-stocked gift shop offering collectibles at reasonable prices. They also highlight the friendly and knowledgeable staff and volunteers who enhance the experience with their insights into the history of auto racing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-376b-7000-9bf9-ba799f01f0b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-376b-7000-9bf9-ba799f01f0b5",
        "storage_key": "property/6767906449164260/019d0812-376b-7000-9bf9-ba799f01f0b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ncarhof.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7255910339999595788",
      "poi_item_slug": "north-carolina-auto-racing-hall-of-fame",
      "poi_latitude": "35.59",
      "poi_longitude": "-80.8644444",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-663-5331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-738a-7783-b14d-b5b5de880ef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-738a-7783-b14d-b5b5de880ef8",
        "storage_key": "property/6767906449164260/019d0812-738a-7783-b14d-b5b5de880ef8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ68hgWN1UUYgRDH3CwQIssmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_af7ae3ab-8a26-4b26-8f01-f1975bec462f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Memory Lane Museum",
      "poi_type": "Entertainment",
      "poi_address": "769 River Hwy, Mooresville, NC 28117, USA",
      "poi_short_description": "Over 100 vehicles, including race cars, classics, and movie cars, are on display at this destination.",
      "poi_long_description": "Car museum exhibiting 150+ antique & classic vehicles & objects related to racing history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-3a2e-75ea-9e71-cc8d3ef602cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-3a2e-75ea-9e71-cc8d3ef602cc",
        "storage_key": "property/6767906449164260/019d0812-3a2e-75ea-9e71-cc8d3ef602cc.webp",
        "width": 604,
        "height": 453
      },
      "poi_business_url": "http://www.memorylaneautomuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3222361362169058311",
      "poi_item_slug": "memory-lane-museum",
      "poi_latitude": "35.5964714",
      "poi_longitude": "-80.8850278",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-662-3673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-738a-7783-b14d-b5b5de880ef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-738a-7783-b14d-b5b5de880ef8",
        "storage_key": "property/6767906449164260/019d0812-738a-7783-b14d-b5b5de880ef8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJwZX0KJdUUYgRB9QHCpYguCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_23d23993-ab7d-4c93-9a06-e7957d632fd3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Coach Joe Popp Stadium",
      "poi_type": "Entertainment",
      "poi_address": "160 S Magnolia St, Mooresville, NC 28115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-3af5-73bb-8d46-bb482962e94e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-3af5-73bb-8d46-bb482962e94e",
        "storage_key": "property/6767906449164260/019d0812-3af5-73bb-8d46-bb482962e94e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mhs.mgsd.k12.nc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16632948335470675721",
      "poi_item_slug": "coach-joe-popp-stadium",
      "poi_latitude": "35.5755468",
      "poi_longitude": "-80.7988944",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7386-743e-a4d0-1831d9ff2e8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7386-743e-a4d0-1831d9ff2e8b",
        "storage_key": "property/6767906449164260/019d0812-7386-743e-a4d0-1831d9ff2e8b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMXs99e__U4gRCYcnz2Ia1OY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_c44a2404-e586-4031-b0ee-6de937a2a697",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Mooresville Museum",
      "poi_type": "Entertainment",
      "poi_address": "132 E Center Ave, Mooresville, NC 28115, USA",
      "poi_short_description": "Nonprofit museum exploring regional history via permanent & rotating exhibits, programs & artifacts.",
      "poi_long_description": "Nonprofit museum exploring regional history via permanent & rotating exhibits, programs & artifacts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-3c1a-703e-8848-63214b436b8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-3c1a-703e-8848-63214b436b8b",
        "storage_key": "property/6767906449164260/019d0812-3c1a-703e-8848-63214b436b8b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.themooresvillemuseum.org/index.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=4918300339433449338",
      "poi_item_slug": "mooresville-museum",
      "poi_latitude": "35.582226",
      "poi_longitude": "-80.8121676",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-663-1873",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-738a-7783-b14d-b5b5de880ef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-738a-7783-b14d-b5b5de880ef8",
        "storage_key": "property/6767906449164260/019d0812-738a-7783-b14d-b5b5de880ef8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85NqGF9VUYgReiedthlQQUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_53474a8c-dc1a-4967-8fa4-fa1766fc40aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Welcome Home Veterans at Richard's Coffee Shop",
      "poi_type": "Entertainment",
      "poi_address": "165 N Main St, Mooresville, NC 28115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-4049-715a-a617-ec46c0757932.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-4049-715a-a617-ec46c0757932",
        "storage_key": "property/6767906449164260/019d0812-4049-715a-a617-ec46c0757932.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.welcomevets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15953655122247510409",
      "poi_item_slug": "welcome-home-veterans-at-richards-coffee-shop",
      "poi_latitude": "35.5830709",
      "poi_longitude": "-80.81149",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-663-0488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-738a-7783-b14d-b5b5de880ef8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-738a-7783-b14d-b5b5de880ef8",
        "storage_key": "property/6767906449164260/019d0812-738a-7783-b14d-b5b5de880ef8.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJKWNJ3l5VUYgRiWmnvs7EZt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_5abea65e-e8ef-4c02-b870-ba6d11e32229",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Lowe's YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "170 Joe Knox Ave, Mooresville, NC 28117, USA",
      "poi_short_description": "Family-friendly center with a gym, as well as a pool, an indoor track, and a variety of classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-4035-74ec-a3db-d4f0b739bf25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-4035-74ec-a3db-d4f0b739bf25",
        "storage_key": "property/6767906449164260/019d0812-4035-74ec-a3db-d4f0b739bf25.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ymcacharlotte.org/locations/lowes-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=10423274653811827989",
      "poi_item_slug": "lowes-ymca",
      "poi_latitude": "35.5915233",
      "poi_longitude": "-80.8767968",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-716-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxY3Zt6qVogRFWXJoBLpppA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_618688b9-c313-49da-8912-4c345562aa96",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "335 W Plaza Dr #1, Mooresville, NC 28117, USA",
      "poi_short_description": "Chain fitness center with tanning beds featuring modern equipment.",
      "poi_long_description": "People say this gym offers a wide variety of cardio machines and is exceptionally clean with friendly and helpful staff. They also highlight the great pricing options and welcoming, judgement-free atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-43cf-7519-9070-25cdb394588a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-43cf-7519-9070-25cdb394588a",
        "storage_key": "property/6767906449164260/019d0812-43cf-7519-9070-25cdb394588a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/mooresville-nc?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17886558358751880463",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.5923311",
      "poi_longitude": "-80.8539201",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 704-230-0909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK5PKLB5VUYgRDyWzaw_SOfg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8642ab08-fc01-4566-a2d6-e51ddda4f111",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Stand For Animals Veterinary Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "2714 Charlotte Hwy, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-4518-70fb-baf2-1204f336c5e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-4518-70fb-baf2-1204f336c5e4",
        "storage_key": "property/6767906449164260/019d0812-4518-70fb-baf2-1204f336c5e4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.standforanimals.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9355582269182213145",
      "poi_item_slug": "stand-for-animals-veterinary-clinic",
      "poi_latitude": "35.5855957",
      "poi_longitude": "-80.8396664",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 704-970-2711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqx53zdtUUYgRGXyMfYG01YE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_3ddb3296-ad38-47ef-90bc-e283b9db7ce1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Crush It Coliseum - Mooresville",
      "poi_type": "Health and Wellness",
      "poi_address": "131 Crosslake Park Dr, Mooresville, NC 28117, USA",
      "poi_short_description": "Gym offering 24/7 access to a friendly facility with world-class equipment.",
      "poi_long_description": "Gym goers say this gym offers a wide variety of top-notch equipment for bodybuilding and powerlifting, including machines for every muscle group. They also highlight the friendly and helpful staff, the clean and well-maintained facility, and the motivating atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-48da-7339-84cd-d0aee70fe280.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-48da-7339-84cd-d0aee70fe280",
        "storage_key": "property/6767906449164260/019d0812-48da-7339-84cd-d0aee70fe280.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crushitcoliseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15208310386454710914",
      "poi_item_slug": "crush-it-coliseum---mooresville",
      "poi_latitude": "35.5897023",
      "poi_longitude": "-80.86826359999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-677-7028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SPxv81VUYgRgkqEKrjFDtM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_40834d3e-41a2-4275-8cc1-879d006202ae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Diesel Barbershop Mooresville Town Square",
      "poi_type": "Health and Wellness",
      "poi_address": "137 Center Square Dr Suite C, Mooresville, NC 28117, USA",
      "poi_short_description": "Modern-day take on the traditional barbershop with video games, sports on TV, and cold beverages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-47dc-768a-9ee0-d2f4cab2a78d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-47dc-768a-9ee0-d2f4cab2a78d",
        "storage_key": "property/6767906449164260/019d0812-47dc-768a-9ee0-d2f4cab2a78d.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.dieselbarbershop.com/location/mooresville-nc-mooresville-town-square?utm_source=googlebusinessprofile",
      "poi_directions_map_url": "https://maps.google.com/?cid=15751476481437880349",
      "poi_item_slug": "diesel-barbershop-mooresville-town-square",
      "poi_latitude": "35.5875727",
      "poi_longitude": "-80.87204659999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 980-444-5217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW1vRlsRVUYgRHVAGrGd8mNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_692c78e7-609e-41ea-9224-826af5aaff34",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Flying High Academy",
      "poi_type": "Health and Wellness",
      "poi_address": "245 Rolling Hill Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-4a3c-73b9-a124-63d9d32d40eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-4a3c-73b9-a124-63d9d32d40eb",
        "storage_key": "property/6767906449164260/019d0812-4a3c-73b9-a124-63d9d32d40eb.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "http://www.flyinghighlakenorman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=123159462268862616",
      "poi_item_slug": "flying-high-academy",
      "poi_latitude": "35.5867655",
      "poi_longitude": "-80.860851",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-235-0539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-18b06b8da46c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-18b06b8da46c",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-18b06b8da46c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXeNtr9__U4gRmIBD3-CMtQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a41149ed-1d15-48fe-8568-acb8d37a4995",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Burn Boot Camp",
      "poi_type": "Health and Wellness",
      "poi_address": "491 Williamson Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "Fitness center offering 45-minute workout sessions that include cardio, strength training, and HIIT.",
      "poi_long_description": "People say this gym offers challenging and varied workouts with top-notch trainers who provide modifications for all fitness levels. They also highlight the motivating and supportive community atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-4c05-707d-a665-979d5a7592d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-4c05-707d-a665-979d5a7592d4",
        "storage_key": "property/6767906449164260/019d0812-4c05-707d-a665-979d5a7592d4.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.burnbootcamp.com/locations/mooresville-nc/?utm_source=gmb&utm_medium=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=9726536904613102203",
      "poi_item_slug": "burn-boot-camp",
      "poi_latitude": "35.5747845",
      "poi_longitude": "-80.8688256",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-619-8512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7_-5mAZVUYgRewIxBsiZ-4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8430d911-9eab-4cb4-9626-420663ce1cbb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Great Clips",
      "poi_type": "Health and Wellness",
      "poi_address": "134 Town Center Dr Ste D, Mooresville, NC 28117, USA",
      "poi_short_description": "Walk-in hair salon offering haircuts for men, women, and kids, plus online check-in.",
      "poi_long_description": "Casual salon offering haircuts for adults & kids along with professional styling products for sale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-4da3-76dc-bb77-2470b4b23f93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-4da3-76dc-bb77-2470b4b23f93",
        "storage_key": "property/6767906449164260/019d0812-4da3-76dc-bb77-2470b4b23f93.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://salons.greatclips.com/us/nc/mooresville/134-town-center-dr?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5683127492126312513",
      "poi_item_slug": "great-clips",
      "poi_latitude": "35.5860435",
      "poi_longitude": "-80.8758813",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-664-4718",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZXuzDCerVogRQQhy9VeG3k4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_e04ecdf1-2a24-4a9f-9f2b-f1e02a2ba95d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Lake Norman at Mooresville Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2681 Charlotte Hwy, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-50a7-71ed-bae1-8529306ceb5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-50a7-71ed-bae1-8529306ceb5f",
        "storage_key": "property/6767906449164260/019d0812-50a7-71ed-bae1-8529306ceb5f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mooresvilleanimalhospital.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6050550214033050044",
      "poi_item_slug": "lake-norman-at-mooresville-animal-hospital",
      "poi_latitude": "35.5871409",
      "poi_longitude": "-80.8374942",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-664-4087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJico6Dz5VUYgRvIkay1zf91M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_b9b1cf5e-9dfb-4cc9-9381-8e6413b28499",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Fuel Fitness Mooresville",
      "poi_type": "Health and Wellness",
      "poi_address": "191-B W Plaza Dr, Mooresville, NC 28117, USA",
      "poi_short_description": "Gym open 24 hours with equipment such as free weights and a smoothie bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-50fa-749b-8618-b804435dbb10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-50fa-749b-8618-b804435dbb10",
        "storage_key": "property/6767906449164260/019d0812-50fa-749b-8618-b804435dbb10.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://fuelfitnessclubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5917885844731011064",
      "poi_item_slug": "fuel-fitness-mooresville",
      "poi_latitude": "35.5896775",
      "poi_longitude": "-80.8442513",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 704-664-4022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVbfOFKJVUYgR-B-BTNKNIFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_964ec036-cbd3-4999-8fb7-a3d492b66aec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Duke Health Lake Norman Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "171 Fairview Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-53d9-77dd-bf89-df7cf73ee7a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-53d9-77dd-bf89-df7cf73ee7a1",
        "storage_key": "property/6767906449164260/019d0812-53d9-77dd-bf89-df7cf73ee7a1.webp",
        "width": 1000,
        "height": 740
      },
      "poi_business_url": "https://www.dukehealth.org/hospitals/duke-health-lake-norman-hospital?utm_source=google&utm_medium=local&utm_campaign=evergreen",
      "poi_directions_map_url": "https://maps.google.com/?cid=1993697169558975001",
      "poi_item_slug": "duke-health-lake-norman-hospital",
      "poi_latitude": "35.5492681",
      "poi_longitude": "-80.85416149999999",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 704-660-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-738b-765d-9214-43ad9246648b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-738b-765d-9214-43ad9246648b",
        "storage_key": "property/6767906449164260/019d0812-738b-765d-9214-43ad9246648b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsbG0cd-qVogRGbJDPQMJqxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8f245a89-d354-47a3-8b9e-f2af9c820d25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Iredell Mooresville",
      "poi_type": "Health and Wellness",
      "poi_address": "653 Bluefield Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-55e1-706a-ab72-15e893b6a641.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-55e1-706a-ab72-15e893b6a641",
        "storage_key": "property/6767906449164260/019d0812-55e1-706a-ab72-15e893b6a641.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://iredellatmooresville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13383047681447796837",
      "poi_item_slug": "iredell-mooresville",
      "poi_latitude": "35.5970431",
      "poi_longitude": "-80.8665197",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 704-360-6650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-738b-765d-9214-43ad9246648b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-738b-765d-9214-43ad9246648b",
        "storage_key": "property/6767906449164260/019d0812-738b-765d-9214-43ad9246648b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJWbswpFhVUYgRZaDPuPUiurk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_82ae93d7-0f1f-4b2c-ba0f-0d9d82d712a0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Lake Norman State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "759 State Park Rd, Troutman, NC 28166, USA",
      "poi_short_description": "State park with paddleboating, kayaking, and fishing, plus an easy hiking trail.",
      "poi_long_description": "Visitors say this state park offers a variety of activities, including hiking, biking, fishing, kayaking, and swimming, with scenic views of the lake. They also highlight the relaxing and peaceful atmosphere, perfect for enjoying nature and escaping the everyday hustle and bustle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-579c-7602-b260-083e55b38693.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-579c-7602-b260-083e55b38693",
        "storage_key": "property/6767906449164260/019d0812-579c-7602-b260-083e55b38693.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ncparks.gov/lake-norman-state-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1930663554612001173",
      "poi_item_slug": "lake-norman-state-park",
      "poi_latitude": "35.6618776",
      "poi_longitude": "-80.94082499999999",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 704-528-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7834-77ae-b76b-2f26c60729c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7834-77ae-b76b-2f26c60729c4",
        "storage_key": "property/6767906449164260/019d0812-7834-77ae-b76b-2f26c60729c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQCjdtVTUYgRlflwGUYYyxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_b67c9501-7cad-4907-90f1-7587cb930c8f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Trump National Golf Club Charlotte",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "120 Trump Sq, Mooresville, NC 28117, USA",
      "poi_short_description": "Golf course and country club featuring state-of-the-art amenities on the shores of Lake Norman.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-581c-73cc-b94a-49733e5fe9ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-581c-73cc-b94a-49733e5fe9ce",
        "storage_key": "property/6767906449164260/019d0812-581c-73cc-b94a-49733e5fe9ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.trumpnationalcharlotte.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=855949989935736868",
      "poi_item_slug": "trump-national-golf-club-charlotte",
      "poi_latitude": "35.5327562",
      "poi_longitude": "-80.9185289",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 980-514-1860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7893-73cf-823f-77b106f6987a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7893-73cf-823f-77b106f6987a",
        "storage_key": "property/6767906449164260/019d0812-7893-73cf-823f-77b106f6987a.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJX20OQ4qsVogRJGieF_vx4As",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_7c79dac6-3a28-417b-a13d-4b106a4f2ab5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Mooresville Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "205 Golf Course Dr, Mooresville, NC 28115, USA",
      "poi_short_description": "Public golf course offering a variety of holes and practice facilities, plus a restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-5a93-72fd-aed6-20a6f40faebe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-5a93-72fd-aed6-20a6f40faebe",
        "storage_key": "property/6767906449164260/019d0812-5a93-72fd-aed6-20a6f40faebe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mooresvillegolfclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2393178886853167867",
      "poi_item_slug": "mooresville-golf-course",
      "poi_latitude": "35.5746688",
      "poi_longitude": "-80.8359756",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-663-2539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7893-73cf-823f-77b106f6987a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7893-73cf-823f-77b106f6987a",
        "storage_key": "property/6767906449164260/019d0812-7893-73cf-823f-77b106f6987a.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJVaylgDlVUYgR-wrZmoRHNiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_f1b739b1-928e-451b-a661-c39758c5fd07",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Stumpy Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "160 Stumpy Creek Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "83-acre park with a playground, soccer field, disc golf course, baseball diamonds & picnic shelters.",
      "poi_long_description": "83-acre park with a playground, soccer field, disc golf course, baseball diamonds & picnic shelters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-5bfd-7261-9286-6c2dbbf30efe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-5bfd-7261-9286-6c2dbbf30efe",
        "storage_key": "property/6767906449164260/019d0812-5bfd-7261-9286-6c2dbbf30efe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.co.iredell.nc.us/Facilities/Facility/Details/Stumpy-Creek-Park-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=15170207520819936341",
      "poi_item_slug": "stumpy-creek-park",
      "poi_latitude": "35.6288407",
      "poi_longitude": "-80.8979234",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 704-878-3103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7834-77ae-b76b-2f26c60729c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7834-77ae-b76b-2f26c60729c4",
        "storage_key": "property/6767906449164260/019d0812-7834-77ae-b76b-2f26c60729c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfQyXnZUUYgRVXxub11nh9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9102923c-079a-4a3f-83e8-e8340247e2e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Cornelius Road Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "247 Cornelius Rd, Mooresville, NC 28115, USA",
      "poi_short_description": "Park with baseball fields, tennis courts, a playground, picnic tables, and walking trails, plus a dog park.",
      "poi_long_description": "Visitors say this park offers a dog park, playgrounds, tennis courts, and walking trails. They also highlight the park's peaceful atmosphere and abundance of trees and wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-5e9e-7171-bb8d-6b00943952b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-5e9e-7171-bb8d-6b00943952b5",
        "storage_key": "property/6767906449164260/019d0812-5e9e-7171-bb8d-6b00943952b5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mooresvillenc.gov/government/departments/parks___recreation/parks/cornelius_road_park.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=4098191961254135200",
      "poi_item_slug": "cornelius-road-park",
      "poi_latitude": "35.6133198",
      "poi_longitude": "-80.84394619999999",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 704-663-7026",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7834-77ae-b76b-2f26c60729c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7834-77ae-b76b-2f26c60729c4",
        "storage_key": "property/6767906449164260/019d0812-7834-77ae-b76b-2f26c60729c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDT1k7ahVUYgRoAXqJ-Cz3zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d1db6966-372b-4777-a9c0-17fb79b2182a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Lake Norman Airpark (14A)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Yeager Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-5f71-7726-aad1-62f929b3739a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-5f71-7726-aad1-62f929b3739a",
        "storage_key": "property/6767906449164260/019d0812-5f71-7726-aad1-62f929b3739a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lakenormanairpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6477949662988267252",
      "poi_item_slug": "lake-norman-airpark-14a",
      "poi_latitude": "35.6108447",
      "poi_longitude": "-80.8969753",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 704-662-6227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-788b-706b-8e8f-88afec810397.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-788b-706b-8e8f-88afec810397",
        "storage_key": "property/6767906449164260/019d0812-788b-706b-8e8f-88afec810397.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QWa4H9TUYgR9O5Gl-VM5lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_0edcb3ad-a0bb-4bab-99e0-537ed5440a5d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Jordan’s Transportation",
      "poi_type": "Transportation & Transit",
      "poi_address": "115 Forest Ridge Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2126494229112899928",
      "poi_item_slug": "jordans-transportation",
      "poi_latitude": "35.5792498",
      "poi_longitude": "-80.8589198",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 516-765-6420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-788b-706b-8e8f-88afec810397.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-788b-706b-8e8f-88afec810397",
        "storage_key": "property/6767906449164260/019d0812-788b-706b-8e8f-88afec810397.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJvUpypz1VUYgRWEkxFzzTgh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_6a9cdeee-b3ad-4579-b57e-caa439d18e2a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Lowe's Design Center (Formerly TPOG)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "286 Houston Rd, Troutman, NC 28166, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6145-7473-a731-df63e8e6b339.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-6145-7473-a731-df63e8e6b339",
        "storage_key": "property/6767906449164260/019d0812-6145-7473-a731-df63e8e6b339.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.loweslink.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5991753285680314387",
      "poi_item_slug": "lowes-design-center-formerly-tpog",
      "poi_latitude": "35.6770647",
      "poi_longitude": "-80.8489389",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 704-528-2860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ-31t11WUYgREzjBHt77JlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_59e41a6e-39dd-4678-b533-3aeff2f6bfea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Spire Motorsports",
      "poi_type": "Major Employers & Offices",
      "poi_address": "351 Mazeppa Rd, Mooresville, NC 28115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6440-759f-b542-da5a40f5a687.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-6440-759f-b542-da5a40f5a687",
        "storage_key": "property/6767906449164260/019d0812-6440-759f-b542-da5a40f5a687.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://spire-motorsports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3855875489328967428",
      "poi_item_slug": "spire-motorsports",
      "poi_latitude": "35.61993",
      "poi_longitude": "-80.8042553",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 704-662-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX91Ts28bVIgRBK-WB1TSgjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8134e870-b8dd-4144-a46b-45b5a540f8bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "MSI Defense Solutions, LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "136 Knob Hill Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.msidefense.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6609693012277426112",
      "poi_item_slug": "msi-defense-solutions-llc",
      "poi_latitude": "35.5913085",
      "poi_longitude": "-80.86545559999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 704-660-8348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9akCuhUUYgRwHctZ8ZYuls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_62000969-f1d5-48ec-90b6-3dba89e43c87",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Town of Mooresville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "413 N Main St, Mooresville, NC 28115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-68a4-74dd-85b2-cf00ed192a43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-68a4-74dd-85b2-cf00ed192a43",
        "storage_key": "property/6767906449164260/019d0812-68a4-74dd-85b2-cf00ed192a43.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mooresvillenc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5000705803804570068",
      "poi_item_slug": "town-of-mooresville",
      "poi_latitude": "35.58572789999999",
      "poi_longitude": "-80.8076945",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-663-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7893-73cf-823f-72462bc8663d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7893-73cf-823f-72462bc8663d",
        "storage_key": "property/6767906449164260/019d0812-7893-73cf-823f-72462bc8663d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVW12M1BVUYgR1HEBBm8TZkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_959af99b-6b27-4e6a-95a6-e3b951fb25ac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Alliance Fleet, LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1077 Mecklenburg Hwy, Mooresville, NC 28115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-66f8-7158-a8dc-6ee88f961e47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0812-66f8-7158-a8dc-6ee88f961e47",
        "storage_key": "property/6767906449164260/019d0812-66f8-7158-a8dc-6ee88f961e47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.alliancefleet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10565396136731835368",
      "poi_item_slug": "alliance-fleet-llc",
      "poi_latitude": "35.56228",
      "poi_longitude": "-80.8310953",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 704-585-8331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscSSxXirVogR6Hsv-c7Tn5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5a463062-3f5e-481c-9a85-9581c35341c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Lake Norman High School",
      "poi_type": "Education",
      "poi_address": "186 Doolie Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8dd-76fd-77e2-8a90-79692335ba6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8dd-76fd-77e2-8a90-79692335ba6d",
        "storage_key": "property/6767906449164260/019ea8dd-76fd-77e2-8a90-79692335ba6d.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://lakenormanhigh.issnc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15473459269119275816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-norman-high-school",
      "poi_latitude": "35.5975561",
      "poi_longitude": "-80.90193459999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-799-8555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-18b06b8da46c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-18b06b8da46c",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-18b06b8da46c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb6uSF2FTUYgRKHNULjnFvNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1cdfd618-2ae2-4ba2-9121-5bd710be8263",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Lakeshore Middle School",
      "poi_type": "Education",
      "poi_address": "244 Lakeshore School Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.iss.k12.nc.us/Domain/387",
      "poi_directions_map_url": "https://maps.google.com/?cid=10155134766083152845&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lakeshore-middle-school",
      "poi_latitude": "35.6075627",
      "poi_longitude": "-80.88749969999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-799-0187",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-18b06b8da46c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-18b06b8da46c",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-18b06b8da46c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ70hBEodUUYgRzRub-kNJ7ow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7bb9d598-1415-434c-b17a-caba08a09d23",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Hope Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "106 Montibello Dr, Mooresville, NC 28117, USA",
      "poi_short_description": "Modest gathering spot with picnic shelters, a playground & a splash pad open in summer.",
      "poi_long_description": "People say this park offers a playground, splash pad, and plenty of shade. They highlight the park is clean, well-maintained, and safe, with separate play areas for different age groups. They also like the rubberized ground cover, which is easy for toddlers to walk on and provides a soft landing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8dd-7d8c-763f-9847-a20747377f7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8dd-7d8c-763f-9847-a20747377f7b",
        "storage_key": "property/6767906449164260/019ea8dd-7d8c-763f-9847-a20747377f7b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mooresvillenc.gov/government/departments/parks___recreation/parks/hope_park.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=16161053283892468715&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hope-park",
      "poi_latitude": "35.5929525",
      "poi_longitude": "-80.8776543",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-663-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7834-77ae-b76b-2f26c60729c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7834-77ae-b76b-2f26c60729c4",
        "storage_key": "property/6767906449164260/019d0812-7834-77ae-b76b-2f26c60729c4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaeFCPJVUUYgR6xuSNlaYR-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_51db2d7f-5eb2-4b60-b1e7-24f049201009",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Mooresville Public Library - West Branch",
      "poi_type": "Education",
      "poi_address": "614 Brawley School Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8dd-7b2e-7768-b11b-62a3ffa33780.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8dd-7b2e-7768-b11b-62a3ffa33780",
        "storage_key": "property/6767906449164260/019ea8dd-7b2e-7768-b11b-62a3ffa33780.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mooresvillenc.gov/government/departments/library/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=9277248791898010963&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mooresville-public-library---west-branch",
      "poi_latitude": "35.5840975",
      "poi_longitude": "-80.87506710000001",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-799-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7893-73cf-823f-72462bc8663d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7893-73cf-823f-72462bc8663d",
        "storage_key": "property/6767906449164260/019d0812-7893-73cf-823f-72462bc8663d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOa5oj6VVUYgRU7UAjp9ov4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_54d1183d-d401-49a5-8eb4-63eee03f596e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "The Charles Mack Citizen Center",
      "poi_type": "Entertainment",
      "poi_address": "215 N Main St #2527, Mooresville, NC 28115, USA",
      "poi_short_description": "Large meeting and event center featuring a variety of rooms and an auditorium hosting cultural performances.",
      "poi_long_description": "People say this convention center is a beautiful and spacious facility, offering a wide variety of activities and accommodating various events like meetings and dinner theatre. Visitors highlight the consistently clean and well-maintained environment. They also mention the friendly and helpful staff, contributing to a fun atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8dd-76e5-71cb-93c7-cda519c7d1da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8dd-76e5-71cb-93c7-cda519c7d1da",
        "storage_key": "property/6767906449164260/019ea8dd-76e5-71cb-93c7-cda519c7d1da.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.experiencecmcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8891758616324774703&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-charles-mack-citizen-center",
      "poi_latitude": "35.5833891",
      "poi_longitude": "-80.8105274",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-662-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBfKgGeD_U4gRL5uO2lnfZXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_d9eb87f8-f54a-4de8-a637-057de4127812",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Lazy 5 Ranch",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15100 Mooresville Rd, Mooresville, NC 28115, USA",
      "poi_short_description": "Zoo with domestic & exotic animals from 6 continents, with wagon rides & petting areas.",
      "poi_long_description": "People say this zoo offers a fun drive-through safari and wagon ride where visitors can see and feed a variety of animals, including giraffes, zebras, and llamas. They highlight the family-friendly atmosphere, the opportunity for close animal interactions, and the value of the experience. They also like the friendly and informative staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8dd-7aad-70a2-b077-77a14e66fa47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8dd-7aad-70a2-b077-77a14e66fa47",
        "storage_key": "property/6767906449164260/019ea8dd-7aad-70a2-b077-77a14e66fa47.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lazy5ranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16688718849253472510&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lazy-5-ranch",
      "poi_latitude": "35.6229867",
      "poi_longitude": "-80.7204787",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-663-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPyhzNzX5U4gR_ngebl89muc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_8b867b08-0bf2-421b-89e0-56d089429f55",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "The Pit Indoor Kart Racing",
      "poi_type": "Entertainment",
      "poi_address": "346 E Plaza Dr, Mooresville, NC 28115, USA",
      "poi_short_description": "Activity center featuring go-kart racing, laser tag, mini golf, a climbing wall, arcade & billiards.",
      "poi_long_description": "Visitors say this entertainment center offers fast go-karts on a fun, challenging track, along with a wide variety of activities like laser tag, arcade games, and mini-golf. They also highlight the reasonable prices, family-friendly atmosphere, and helpful, friendly staff.\n\nSome reviews mention many of the arcade games can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8dd-774e-76df-9784-91ff799d0484.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8dd-774e-76df-9784-91ff799d0484",
        "storage_key": "property/6767906449164260/019ea8dd-774e-76df-9784-91ff799d0484.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.meetatthepit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17884552632589156098&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-pit-indoor-kart-racing",
      "poi_latitude": "35.5907402",
      "poi_longitude": "-80.82189939999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-799-3470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSVU1kmhVUYgRAv9A6NyxMvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "go_karting_venue"
    },
    {
      "id": "custom_4e1fa1e6-1ade-4366-b1ed-8458a3706c0d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Carrigan Farms",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1261 Oakridge Farm Hwy, Mooresville, NC 28115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8dd-76d7-7493-887a-a63a308a401b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8dd-76d7-7493-887a-a63a308a401b",
        "storage_key": "property/6767906449164260/019ea8dd-76d7-7493-887a-a63a308a401b.webp",
        "width": 496,
        "height": 597
      },
      "poi_business_url": "http://www.carriganfarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=252838924303580389&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carrigan-farms",
      "poi_latitude": "35.6002099",
      "poi_longitude": "-80.76886569999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-664-1450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-5zKm6v_U4gR5byBfKlDggM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farm"
    },
    {
      "id": "custom_f6d627da-2e7b-4964-9466-85d97066ee4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Mooresville Skate Park",
      "poi_type": "Entertainment",
      "poi_address": "748 W Iredell Ave, Mooresville, NC 28115, USA",
      "poi_short_description": "Well-lit locale featuring bowls, ramps and rails for all skill sets.",
      "poi_long_description": "Visitors say this skate park is well-designed with a variety of obstacles for all skill levels, including bowls, ledges, and rails. They also highlight the clean and well-maintained restrooms, as well as the welcoming and friendly community.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-9e64-75c8-ac1a-3735eb0a2121.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e0-9e64-75c8-ac1a-3735eb0a2121",
        "storage_key": "property/6767906449164260/019ea8e0-9e64-75c8-ac1a-3735eb0a2121.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.strayrocket.com/mooresville-skatepark/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11013578656093387307&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mooresville-skate-park",
      "poi_latitude": "35.59268369999999",
      "poi_longitude": "-80.8167027",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-662-0348",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvVI2F2RVUYgRKzpFbm8X2Jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "skateboard_park"
    },
    {
      "id": "custom_3a507c18-ed18-4eb1-a54c-595fd28ab7c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Epic Chophouse",
      "poi_type": "Restaurants",
      "poi_address": "104 S Main St, Mooresville, NC 28115, USA",
      "poi_short_description": "Steaks & seafood are served in a spare, refined space inside a renovated 19th-century building.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, including filet mignon, ribeye, and prime rib, as well as appetizers like cheese toast and bacon. They highlight the generous portions, the excellent drinks, and the elegant atmosphere. They also like the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-9f39-74ba-b7fe-7a03bb25a121.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e0-9f39-74ba-b7fe-7a03bb25a121",
        "storage_key": "property/6767906449164260/019ea8e0-9f39-74ba-b7fe-7a03bb25a121.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "http://www.epicchophouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10145305634879882218&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "epic-chophouse",
      "poi_latitude": "35.5823435",
      "poi_longitude": "-80.8128149",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-230-1720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6ed9-704e-9a92-376db3942157",
        "storage_key": "property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrXEDHl9VUYgR6sPICLldy4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_8dc28271-13c7-4aa9-9507-112e8ddda3d5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Jeffrey's Restaurant - Mooresville, NC",
      "poi_type": "Restaurants",
      "poi_address": "117 Trade Ct, Mooresville, NC 28117, USA",
      "poi_short_description": "Slick but easygoing hangout featuring New American eats with a Southern bent, cocktails & a patio.",
      "poi_long_description": "Diners say this restaurant offers delicious food, with highlights including perfectly cooked steaks, crab cakes, and flavorful blackened chicken pasta. They also mention the beautiful atmosphere, excellent service, and reasonable prices.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-a242-71a0-bf8e-3a03effefb9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e0-a242-71a0-bf8e-3a03effefb9f",
        "storage_key": "property/6767906449164260/019ea8e0-a242-71a0-bf8e-3a03effefb9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jeffreyslkn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9488538399710192221&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jeffreys-restaurant---mooresville-nc",
      "poi_latitude": "35.5543083",
      "poi_longitude": "-80.8553381",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-799-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6ed9-704e-9a92-376db3942157",
        "storage_key": "property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yG5nSerVogRXSJh8GYProM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8df9d016-46ba-48f0-85fb-8006909a5d9b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Summit Coffee Mooresville",
      "poi_type": "Restaurants",
      "poi_address": "107 E Moore Ave, Mooresville, NC 28115, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this coffee shop offers delicious coffee, including lattes with unique flavored whipped cream, and tasty blueberry scones. They also highlight the cozy, calming, and beautiful atmosphere, as well as the spotless and well-maintained space. Guests mention the friendly, efficient, and professional staff who provide quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-9df6-705a-923b-ec5ffe178918.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e0-9df6-705a-923b-ec5ffe178918",
        "storage_key": "property/6767906449164260/019ea8e0-9df6-705a-923b-ec5ffe178918.webp",
        "width": 1030,
        "height": 1280
      },
      "poi_business_url": "https://summitcoffee.com/mooresville",
      "poi_directions_map_url": "https://maps.google.com/?cid=15680210818730511734&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "summit-coffee-mooresville",
      "poi_latitude": "35.5832128",
      "poi_longitude": "-80.8108839",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-360-2786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-a829-7600-97a5-0bc432dd2fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ea8e0-a829-7600-97a5-0bc432dd2fef",
        "storage_key": "property/6767906449164260/019ea8e0-a829-7600-97a5-0bc432dd2fef.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJWXtwUyhVUYgRdk2rjalMm9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_acf68d21-a22c-4790-ab69-56251a66f0fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "King Canary Brewing",
      "poi_type": "Restaurants",
      "poi_address": "562 Williamson Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-9950-707a-96b3-a5055b41e64f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e0-9950-707a-96b3-a5055b41e64f",
        "storage_key": "property/6767906449164260/019ea8e0-9950-707a-96b3-a5055b41e64f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kingcanarybrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10620090511042762568&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "king-canary-brewing",
      "poi_latitude": "35.570576",
      "poi_longitude": "-80.8683744",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-235-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcNAtNNVUYgRSFczWQ0kYpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_71740edb-fd2b-4983-9e4c-ac23913a6fdb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Apps & Taps",
      "poi_type": "Restaurants",
      "poi_address": "155 Pinnacle Ln, Mooresville, NC 28117, USA",
      "poi_short_description": "Relaxed restaurant and bar offering live music, a deck overlooking Lake Norman, and comfort eats.",
      "poi_long_description": "People say this bar and grill offers reasonably priced food and has attentive servers. They also highlight the lively atmosphere.\n\nSome reviews mention the food can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-9df0-719a-b3b5-55aab20b2860.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e0-9df0-719a-b3b5-55aab20b2860",
        "storage_key": "property/6767906449164260/019ea8e0-9df0-719a-b3b5-55aab20b2860.webp",
        "width": 1280,
        "height": 805
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17826298481127285119&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "apps--taps",
      "poi_latitude": "35.608065",
      "poi_longitude": "-80.9372838",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-677-7648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-a82e-71cc-b0ca-4aa61c5cf53d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ea8e0-a82e-71cc-b0ca-4aa61c5cf53d",
        "storage_key": "property/6767906449164260/019ea8e0-a82e-71cc-b0ca-4aa61c5cf53d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-tIngRTUYgRf2GtUwW8Y_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_ab46c504-0506-41fb-b6b8-37c66bcd2290",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "JR Motorsports",
      "poi_type": "Entertainment",
      "poi_address": "349 Cayuga Dr, Mooresville, NC 28117, USA",
      "poi_short_description": "Dale Earnhardt Jr.'s sprawling motorsports facility featuring guided tours & a gift shop.",
      "poi_long_description": "Visitors say this motorsports shop offers free guided tours of the race shop floor, allowing an intimate view of cars and mechanics at work, and features a gift shop with a wide variety of merchandise. They also highlight the delicious beef jerky and the opportunity to see the Dirty Mo studio. Guests mention the staff are friendly, knowledgeable, and provide excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-9a85-77dd-8b98-e95710965e61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e0-9a85-77dd-8b98-e95710965e61",
        "storage_key": "property/6767906449164260/019ea8e0-9a85-77dd-8b98-e95710965e61.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.jrmracing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13177696166041656341&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jr-motorsports",
      "poi_latitude": "35.6075692",
      "poi_longitude": "-80.8550564",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-799-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-14ae8055c241.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-14ae8055c241",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-14ae8055c241.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi2-mOv5UUYgRFZzwNtiU4LY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_d6eaa5dc-63cc-4c13-b9b0-55bd7c2e64a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Vitex",
      "poi_type": "Major Employers & Offices",
      "poi_address": "630 Williamson Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.vitex.com/contact/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7448187928299277440&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vitex",
      "poi_latitude": "35.5673454",
      "poi_longitude": "-80.8664033",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-663-2544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ___DvTKrVogRgIyhZnVHXWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "point_of_interest"
    },
    {
      "id": "custom_3c350354-aad9-448d-adb5-975f17dee3c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Midan Marketing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "108 Gateway Blvd #207, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-997a-73fb-9d5b-192360245701.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e0-997a-73fb-9d5b-192360245701",
        "storage_key": "property/6767906449164260/019ea8e0-997a-73fb-9d5b-192360245701.webp",
        "width": 500,
        "height": 500
      },
      "poi_business_url": "https://midanmarketing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1036614431753178978&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "midan-marketing",
      "poi_latitude": "35.555448",
      "poi_longitude": "-80.8545486",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-664-6328",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXwR8duFYUYgRYg-xXVXLYg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_3d0b1cb3-20f5-4e1d-94ad-c2e800e88e06",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Titan Strapping Systems LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "124 Commercial Dr, Mooresville, NC 28115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-99af-72d2-969d-2157197f1c28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e0-99af-72d2-969d-2157197f1c28",
        "storage_key": "property/6767906449164260/019ea8e0-99af-72d2-969d-2157197f1c28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.titanstrapping.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3687891807007488278&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "titan-strapping-systems-llc",
      "poi_latitude": "35.5572562",
      "poi_longitude": "-80.82108889999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-663-2490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ32e4H5ybVogRFjnBJg8GLjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_bbcc5de8-a199-4847-9e8b-8f528ddb20ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Coffee Republic Mooresville",
      "poi_type": "Restaurants",
      "poi_address": "239 W Center Ave, Mooresville, NC 28115, USA",
      "poi_short_description": "Established cafe offering sandwiches, salads & breakfast, plus unique sweet teas & espresso drinks.",
      "poi_long_description": "People say this coffee shop offers smooth, rich, and well-crafted coffee, including lattes, cold brews, and drip coffee. They highlight the spacious, modern interior with a relaxed and inviting vibe, and the friendly, welcoming staff. They also like the reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e2-57d3-7738-a079-b801111334e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e2-57d3-7738-a079-b801111334e0",
        "storage_key": "property/6767906449164260/019ea8e2-57d3-7738-a079-b801111334e0.webp",
        "width": 543,
        "height": 306
      },
      "poi_business_url": "https://coffeerepub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8494528958858681160&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "coffee-republic-mooresville",
      "poi_latitude": "35.5835203",
      "poi_longitude": "-80.8138378",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-249-2969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e0-a829-7600-97a5-0bc432dd2fef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ea8e0-a829-7600-97a5-0bc432dd2fef",
        "storage_key": "property/6767906449164260/019ea8e0-a829-7600-97a5-0bc432dd2fef.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJHSrLCJ9VUYgRSFsKBxWh4nU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_5d96b91d-57df-4581-9d38-7f8cfecb37e6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Fred & June's Books",
      "poi_type": "Shopping & Retail",
      "poi_address": "162 N Main St, Mooresville, NC 28115, USA",
      "poi_short_description": "Welcoming bookstore with a kids' room, plus new and used publications.",
      "poi_long_description": "People say this bookstore offers an incredible selection of new and used books for all ages, including a fantastic children's section and diverse book clubs. Visitors highlight the cozy, welcoming atmosphere and the knowledgeable staff who provide excellent recommendations. They also appreciate the fair prices for used books and the option to trade in books for credit.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e2-5b5a-778f-a658-c16bf214431c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e2-5b5a-778f-a658-c16bf214431c",
        "storage_key": "property/6767906449164260/019ea8e2-5b5a-778f-a658-c16bf214431c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://fredandjunesbooks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=850451471797436357&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fred--junes-books",
      "poi_latitude": "35.5834299",
      "poi_longitude": "-80.8118902",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 833-761-2543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-14ae8055c241.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-14ae8055c241",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-14ae8055c241.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8RT8HOlVUYgRxb8xkxtpzQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_e0222574-21e5-468f-9463-d569d004a637",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Zanders Bistro",
      "poi_type": "Restaurants",
      "poi_address": "505 E Statesville Ave, Mooresville, NC 28115, USA",
      "poi_short_description": "Lively bagel spot serving familiar breakfast platters and sandwiches, and burgers.",
      "poi_long_description": "People say this restaurant serves amazing food, including eggs cooked to order and a variety of bagels with special cream cheese. They highlight the friendly service and comfortable atmosphere. They also like the quick service and no wait time.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e2-583c-7069-9919-5a572ab1da64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e2-583c-7069-9919-5a572ab1da64",
        "storage_key": "property/6767906449164260/019ea8e2-583c-7069-9919-5a572ab1da64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.zandersbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11362520441317028503&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "zanders-bistro",
      "poi_latitude": "35.57886200000001",
      "poi_longitude": "-80.8049462",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-696-8222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6ed9-704e-9a92-376db3942157",
        "storage_key": "property/6767906449164260/019d0812-6ed9-704e-9a92-376db3942157.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrytCCuf_U4gRl_LQ4SPIr50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b45b4aac-0a4e-40e5-8833-121223e97e9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "North Carolina Provisions Company",
      "poi_type": "Shopping & Retail",
      "poi_address": "162 N Broad St Suite B, Mooresville, NC 28115, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e2-582c-724a-8687-33244dcf83fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e2-582c-724a-8687-33244dcf83fb",
        "storage_key": "property/6767906449164260/019ea8e2-582c-724a-8687-33244dcf83fb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://northcarolinaprovisionscompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1632717756680009497&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "north-carolina-provisions-company",
      "poi_latitude": "35.5838087",
      "poi_longitude": "-80.81240939999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 980-332-8233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-14ae8055c241.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-14ae8055c241",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-14ae8055c241.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnZCtmg6LU4gRGXdiMSaUqBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_c3628861-a545-401e-83d2-67de77e380e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Glow Nail Lounge",
      "poi_type": "Entertainment",
      "poi_address": "335 W Plaza Dr suite 2, Mooresville, NC 28117, USA",
      "poi_short_description": "Modern nail salon offering manicures, pedicures, and nail art in a relaxing environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e2-5899-755a-9884-418ef264496d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e2-5899-755a-9884-418ef264496d",
        "storage_key": "property/6767906449164260/019ea8e2-5899-755a-9884-418ef264496d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://adoranailsspa.simplepos.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4717978684349067912&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "adora-nails--spa",
      "poi_latitude": "35.5916346",
      "poi_longitude": "-80.85412529999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-360-2048",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs6xBABZVUYgRiLJ90p2geUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_0ff1ea00-b5e6-452e-bf4c-43029f12f617",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Tina Nails & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "168 Norman Station Blvd N, Mooresville, NC 28117, USA",
      "poi_short_description": "Nail salon offering services such as manicures, pedicures, waxing, and acrylic nail enhancements.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e2-5732-74fe-90b4-e1560191ba0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e2-5732-74fe-90b4-e1560191ba0c",
        "storage_key": "property/6767906449164260/019ea8e2-5732-74fe-90b4-e1560191ba0c.webp",
        "width": 1280,
        "height": 474
      },
      "poi_business_url": "https://tinanailsspamooresville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=616937236137131874&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tina-nails--spa",
      "poi_latitude": "35.5896199",
      "poi_longitude": "-80.85808999999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-696-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAa2UC_NVUYgRYj-qyCXNjwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_ecdcba14-85a0-40f0-8c88-a4600ca303a1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Hoptown Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "107 Plantation Ridge Dr, Mooresville, NC 28117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019ea8e2-5737-735d-a794-f4af2cded257.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea8e2-5737-735d-a794-f4af2cded257",
        "storage_key": "property/6767906449164260/019ea8e2-5737-735d-a794-f4af2cded257.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://www.hoptownbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10866763307817024818&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hoptown-brewing-company",
      "poi_latitude": "35.5880932",
      "poi_longitude": "-80.8748548",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 704-360-9536",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-7387-724f-99e1-4ffad556e410",
        "storage_key": "property/6767906449164260/019d0812-7387-724f-99e1-4ffad556e410.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8bKTBWJVUYgRMr2uZKd_zpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_4189b727-0679-4a68-94dc-a73ed4555258",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "poi_name": "Universal Technical Institute",
      "poi_type": "Education",
      "poi_address": "220 Byers Creek Rd, Mooresville, NC 28117, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/01a034a8-3b3c-7789-97bf-f78babe2db37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a034a8-3b3c-7789-97bf-f78babe2db37",
        "storage_key": "property/6767906449164260/01a034a8-3b3c-7789-97bf-f78babe2db37.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.uti.edu/locations/north-carolina/mooresville?utm_source=google&utm_medium=organic_search&utm_term=google_business_profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=7015011238079322848&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "universal-technical-institute",
      "poi_latitude": "35.605382",
      "poi_longitude": "-80.8549225",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-658-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0812-6eda-77aa-a106-18b06b8da46c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0812-6eda-77aa-a106-18b06b8da46c",
        "storage_key": "property/6767906449164260/019d0812-6eda-77aa-a106-18b06b8da46c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR1nrxv1UUYgR4FoXzY1TWmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    }
  ],
  "office_hours": [
    {
      "id": "custom_16eb32ae-e9f4-4951-8fd0-49c2550f8fbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7e9e6966-fcee-419d-80cf-2d28e53ea123",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8044108f-d126-458e-a621-4650e2675f28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7466b4c1-16cc-4176-9899-b2a31d82b385",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_79b772f1-5173-4c13-8092-9be8d10aa177",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7a20a6b9-e3b4-4039-beb8-4a60ca7cba8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_d5eeb363-7bc9-43af-a0cb-9760dcfe63bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "rating": "5",
      "name": "Josh Cook",
      "text": "Hayley was so helpful during our tour! My husband may be relocated for work near Charlotte, and we were looking into Mooresville since it seemed close by. I honestly didn’t realize how much traffic and commute time there could be, but Hayley was incredibly kind, patient, and informative through the whole process. She made us feel so comfortable and welcomed from the moment we met her. It honestly felt like I had known her forever. We truly appreciated her help and positive energy!",
      "date": "2026-05-22",
      "title": "false"
    },
    {
      "id": "custom_edef44eb-339d-4142-a152-32e9b9169dbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "rating": "5",
      "name": "Tonia Harris",
      "text": "Complex is well-maintained and peaceful. Lots of recent upgrades. Touring with Haylea was a pleasure.",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_45c7423d-641c-4122-a5d2-dda9166045d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "rating": "5",
      "name": "Amber Martin",
      "text": "Haylea Has been a huge help. She is the reason I chose to live here. I moved from out of state and she made the process easy and smooth. I even got to do a tour by video. I started out in a two bedroom and now I moved into a three bedroom and that process was easy as well. They are very attentive to all needs. I am very happy with the new upgrades throughout the complex, this place is really quiet. I enjoy living here. The manager Jessica does a great job running this place. The maintenance team is wonderful. They take care of all issues asap. Overall great experience.",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_694a9577-7eb7-40d2-9f54-f10de89169f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "rating": "5",
      "name": "Sarah Jean McCabe",
      "text": "I love Nova Lake Norman. Our property manager is very kind! They did excellent with our routine maintenance check up and apartments are beautiful, both renovated and unrenovated. The pool upgrades are absolutely beautiful and there's a beautiful dog park!",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_00ec232c-fc5f-43f5-b3ab-538f13fdf018",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "rating": "5",
      "name": "corell ravenell",
      "text": "My name is Latoy Lopes, I’m new to the complex Haley and Jessica are both very nice and very helpful, recently I had an issue with my A/C unit and maintenance were sent out within minutes. My issue was resolved immediately. Thank you",
      "date": "2026-04-24",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e2f9d87c-0914-4aca-a126-f7eb97f551d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e1dd4-d376-71dc-b669-ebab2ec8cff2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd4-d376-71dc-b669-ebab2ec8cff2",
        "storage_key": "property/6767906449164260/019e1dd4-d376-71dc-b669-ebab2ec8cff2.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "1 BR 1 BTH (153 M)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=4655"
    },
    {
      "id": "custom_071388cd-4222-4dbd-97de-360ed98b24ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e1dd4-d376-71dc-b669-ebab2ec8cff2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd4-d376-71dc-b669-ebab2ec8cff2",
        "storage_key": "property/6767906449164260/019e1dd4-d376-71dc-b669-ebab2ec8cff2.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "1 BR 1 BTH (153 Q)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=4659"
    },
    {
      "id": "custom_85cca778-c69e-43d9-9b6c-11cf8ac28329",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e4c27-4293-74b5-b783-8e361d413d99.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4c27-4293-74b5-b783-8e361d413d99",
        "storage_key": "property/6767906449164260/019e4c27-4293-74b5-b783-8e361d413d99.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "2 BR 2 BTH (107-BE)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=4661"
    },
    {
      "id": "custom_fef26d05-fb00-4f2a-85d3-edb8c1c46a2d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e4c27-829e-74a9-8836-9371bfba4bbc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4c27-829e-74a9-8836-9371bfba4bbc",
        "storage_key": "property/6767906449164260/019e4c27-829e-74a9-8836-9371bfba4bbc.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "2 BR 2 BTH (115-G)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=4665"
    },
    {
      "id": "custom_d37b1d17-1524-42d5-a27a-dfddea5c8999",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e4c27-c5a6-76ba-b392-12cb5fceea58.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4c27-c5a6-76ba-b392-12cb5fceea58",
        "storage_key": "property/6767906449164260/019e4c27-c5a6-76ba-b392-12cb5fceea58.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "2 BR 2 BTH (150-L)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=4663"
    },
    {
      "id": "custom_8c4e67d3-0e7a-4af1-96d9-629198392e47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019e4c28-0fc5-71dc-ad15-a438325ea104.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e4c28-0fc5-71dc-ad15-a438325ea104",
        "storage_key": "property/6767906449164260/019e4c28-0fc5-71dc-ad15-a438325ea104.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "3 BR 2 BTH (161-I)",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=4664"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-e2a1-77cd-9f17-b8b7f6fdb2d8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "nova-lake-norman",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260"
    },
    {
      "lead_collector_id": "0198aa47-e304-7028-b179-550f43655dcb",
      "lead_source": "FACEBOOK_ADS",
      "name": "nova-lake-norman",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260"
    },
    {
      "lead_collector_id": "0198aa47-e366-74c9-a0cf-77a18ad6e640",
      "lead_source": "LANDING_PAGE",
      "name": "nova-lake-norman",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "apartments-with-washer-dryer-mooresville-nc",
      "search_query": "apartments with washer dryer Mooresville NC",
      "category": "Amenity",
      "h1_title": "Apartments with Washer Dryer in Mooresville, NC",
      "h2_subtitle": "Discover premium apartments with a washer dryer included in Mooresville, NC at NOVA Lake Norman. Enjoy the convenience of in-home laundry today.",
      "page_copy": "At NOVA Lake Norman, located in Mooresville, NC, experience the unparalleled convenience of having a washer dryer right in your apartment. Choose from our selection of stylish one, two, and three-bedroom floor plans, each designed with modern living in mind. Imagine coming home to vaulted ceilings and the soothing sight of our tranquil pool, perfect for relaxing after a day of exploring Iredell County.\n\nOur community embraces comfort and ease, providing features that truly enhance your lifestyle. With on-site amenities like a price leader option and first-floor availability, you'll find everything you need right here. Whether you're scheduling a tour or checking availability, NOVA Lake Norman is ready to welcome you home. Don't miss out on the opportunity to live in these premier Mooresville, NC apartments with washer dryer units.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Washer Dryer in Mooresville, NC",
      "seo_description": "Explore modern Mooresville, NC apartments at NOVA Lake Norman with in-home washer dryers. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "pool-view-apartments-near-lake-norman",
      "search_query": "pool view apartments near Lake Norman",
      "category": "Amenity",
      "h1_title": "Pool View Apartments Near Lake Norman",
      "h2_subtitle": "Discover stunning pool view apartments near Lake Norman at NOVA Lake Norman. Enjoy serene vistas and modern comforts in Mooresville, NC.",
      "page_copy": "Experience the tranquility of pool view apartments near Lake Norman at NOVA Lake Norman in Mooresville, NC. Our community offers chic one, two, and three-bedroom apartments that boast scenic views of our refreshing pool, designed to enhance your daily living experience. Imagine relaxing on your balcony, soaking up the peaceful environment right in Iredell County.\n\nBeyond aesthetic appeal, our apartments are equipped with features like vaulted ceilings and in-home washer dryers, ensuring you enjoy both comfort and convenience. Located minutes away from the lake, NOVA Lake Norman is perfect for those who appreciate the beauty of nature and the luxury of modern amenities. Explore our availability today and take the next step towards living in a serene, pool-side paradise.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool View Apartments Near Lake Norman",
      "seo_description": "Enjoy breathtaking pool views at NOVA Lake Norman apartments near Lake Norman. Modern living in Mooresville, NC awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "mooresville-vaulted-ceiling-apartment-rentals",
      "search_query": "Mooresville vaulted ceiling apartment rentals",
      "category": "Amenity",
      "h1_title": "Mooresville Vaulted Ceiling Apartment Rentals",
      "h2_subtitle": "Explore Mooresville vaulted ceiling apartment rentals at NOVA Lake Norman. Enjoy added space and style in our premier homes.",
      "page_copy": "Discover the unique charm of vaulted ceiling apartment rentals at NOVA Lake Norman in Mooresville, NC. Our community offers a selection of spacious one, two, and three-bedroom layouts, each designed to maximize your living space and provide an airy, open feel. These architectural features not only enhance the aesthetic appeal of your home but also create a refreshing ambiance perfect for relaxing or entertaining.\n\nNOVA Lake Norman is more than just beautiful apartments; it's a lifestyle. Located in Iredell County, our community provides easy access to Lake Norman and all the recreational activities it offers. Alongside the stylish design, residents enjoy amenities like pool views and in-unit washer dryers, making it a convenient choice for modern living. Schedule a visit today to see our Mooresville vault ceiling rentals firsthand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mooresville Vaulted Ceiling Apartment Rentals",
      "seo_description": "Find spacious Mooresville apartment rentals with vaulted ceilings at NOVA Lake Norman. Experience elegant living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "affordable-first-floor-apartments-mooresville",
      "search_query": "affordable first floor apartments Mooresville",
      "category": "Amenity",
      "h1_title": "Affordable First Floor Apartments in Mooresville",
      "h2_subtitle": "Find affordable first floor apartments in Mooresville at NOVA Lake Norman. Enjoy easy access and modern amenities.",
      "page_copy": "NOVA Lake Norman is your destination for affordable first floor apartments in Mooresville, NC. Perfectly designed for convenience, these residences offer easy accessibility along with modern living. Enjoy spacious one, two, and three-bedroom options that cater to a variety of lifestyles while ensuring comfort and style in Iredell County.\n\nOur community is built around enhancing your everyday experience. With first floor availability, residents benefit from quick access, making moving in and out a breeze. Combined with features like serene pool views and in-home washer dryers, NOVA Lake Norman ensures that comfort and practicality come together. Whether you're looking to schedule a tour or browse availability, our Mooresville community awaits with open arms.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Affordable First Floor Apartments in Mooresville",
      "seo_description": "Discover affordable first floor living at NOVA Lake Norman in Mooresville, NC. Modern apartments with convenient lifestyle amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "nova-lake-norman-price-leader-iredell-county",
      "search_query": "NOVA Lake Norman price leader Iredell County",
      "category": "Amenity",
      "h1_title": "NOVA Lake Norman: Price Leader in Iredell",
      "h2_subtitle": "Explore NOVA Lake Norman, the price leader in Iredell County. Discover unmatched value and style in our Mooresville community.",
      "page_copy": "At NOVA Lake Norman, we are proud to be recognized as a price leader in Iredell County, offering exceptional value without compromising on quality or style. Our community in Mooresville, NC, features a range of thoughtfully designed one, two, and three-bedroom apartment homes, each outfitted with modern amenities such as vaulted ceilings and in-unit washers and dryers.\n\nCatering to a variety of lifestyles, NOVA Lake Norman combines affordability with all the comforts of upscale living. Residents enjoy scenic pool views and convenient first-floor options, making it an ideal choice for those seeking both luxury and value in Mooresville. Come visit us to experience why NOVA Lake Norman stands out as the price leader in the area, and find your next home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "NOVA Lake Norman: Price Leader in Iredell",
      "seo_description": "NOVA Lake Norman is the price leader in Iredell County, offering quality apartments in Mooresville, NC, at exceptional value.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "studio-apartments-mooresville-nc",
      "search_query": "studio apartments mooresville nc",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Mooresville, NC",
      "h2_subtitle": "Discover studio apartments in Mooresville, NC at NOVA Lake Norman. Ideal for modern living with excellent amenities.",
      "page_copy": "Welcome to NOVA Lake Norman, where we offer stylish studio apartments in the heart of Mooresville, NC. Perfect for singles or those seeking a minimalist lifestyle, our studio homes are designed to maximize space and offer a comfortable living environment. Located in Iredell County, this community provides modern conveniences in a vibrant setting.\n\nEach studio apartment comes with features designed to enhance everyday life, like high ceilings that add a sense of openness, and essential in-unit washer and dryer. With our competitive pricing, NOVA Lake Norman is a premier choice for those seeking both comfort and affordability. Embrace the convenience of first-floor living, scenic pool views, and more. Visit us and see why our studio apartments are among the best in Mooresville.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Mooresville, NC",
      "seo_description": "Find modern studio apartments in Mooresville, NC, at NOVA Lake Norman with top amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-near-lake-norman",
      "search_query": "1 bedroom apartments near lake norman",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments Near Lake Norman",
      "h2_subtitle": "Explore modern 1 bedroom apartments near Lake Norman. NOVA Lake Norman offers style and convenience.",
      "page_copy": "Discover the perfect blend of comfort and convenience with our 1 bedroom apartments near Lake Norman at NOVA Lake Norman. Situated in Mooresville, NC, our community offers an enticing location combined with modern amenities like vaulted ceilings and in-unit washers and dryers. Ideal for singles or couples, these apartments provide both style and functionality.\n\nExperience amazing views, including serene pool vistas, as part of your daily life. As a resident of NOVA Lake Norman, enjoy being close to the scenic beauty of Lake Norman while benefiting from the vibrant lifestyle our community promotes. Whether you're planning a move or looking for availability, our 1 bedroom options provide spacious, well-designed living close to all that Lake Norman has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments Near Lake Norman",
      "seo_description": "Discover 1 bedroom apartments near Lake Norman at NOVA Lake Norman in Mooresville, NC. Modern living with great amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-iredell-county",
      "search_query": "2 bedroom apartments iredell county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Iredell County",
      "h2_subtitle": "Find the perfect 2 bedroom apartments in Iredell County at NOVA Lake Norman. Enjoy modern amenities and a welcoming community.",
      "page_copy": "NOVA Lake Norman proudly offers spacious 2 bedroom apartments in Iredell County, designed with your comfort in mind. Located in the charming town of Mooresville, NC, our community provides a perfect retreat with the convenience of modern living. Each apartment features vaulted ceilings and in-unit washers and dryers, ensuring a high-quality lifestyle.\n\nOur community's layout and amenities, including lovely pool views, cater to those seeking a peaceful yet connected living environment. Whether you're a growing family or roommates looking for the ideal shared space, NOVA Lake Norman delivers exceptional value and comfort. Explore what makes our 2 bedroom apartments a standout choice in the area and consider making NOVA Lake Norman your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Iredell County",
      "seo_description": "Explore spacious 2 bedroom apartments in Iredell County at NOVA Lake Norman, Mooresville, NC. Modern amenities in a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-in-zip-28117",
      "search_query": "3 bedroom apartments in zip 28117",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Zip 28117",
      "h2_subtitle": "Explore spacious 3 bedroom apartments in zip code 28117. NOVA Lake Norman offers perfect family living with great community amenities.",
      "page_copy": "Welcome to NOVA Lake Norman, where our 3 bedroom apartments in zip 28117 offer the ideal combination of space and luxury. Situated in Mooresville, NC, our community is designed for families and those who appreciate ample living quarters. Each apartment includes modern amenities such as vaulted ceilings and convenient in-home washers and dryers, enhancing both comfort and practicality.\n\nLocated in the scenic area of Iredell County, residents benefit from stunning pool views that complement the relaxed atmosphere of our community. Our prime location in the heart of Mooresville provides easy access to local attractions while maintaining a peaceful retreat. Choose NOVA Lake Norman for your next home and experience superior living in our thoughtfully designed 3 bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Zip 28117",
      "seo_description": "Discover spacious 3 bedroom apartments in zip code 28117 at NOVA Lake Norman, Mooresville. Perfect family living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "apartments-near-duke-health-lake-norman",
      "search_query": "apartments near Duke Health Lake Norman",
      "category": "Hospital",
      "h1_title": "Apartments Near Duke Health Lake Norman",
      "h2_subtitle": "Discover modern apartments near Duke Health Lake Norman. NOVA Lake Norman offers convenience and comfort just moments away.",
      "page_copy": "Find your next home at NOVA Lake Norman, offering premier apartments near Duke Health Lake Norman in Mooresville, NC. Our community provides an ideal location for healthcare professionals and individuals seeking proximity to the hospital's advanced medical facilities without sacrificing comfort or style.\n\nResidents enjoy convenient living with amenities like vaulted ceilings, in-unit washers and dryers, and beautiful pool views. Perfectly positioned in Iredell County, NOVA Lake Norman is more than a home—it's a community that supports your lifestyle. Experience modern living close to Duke Health Lake Norman and enjoy the balance of convenience and relaxation our apartments offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Duke Health Lake Norman",
      "seo_description": "Explore modern apartments near Duke Health Lake Norman at NOVA Lake Norman, Mooresville, NC. Ideal location with stylish amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "nova-lake-norman-close-to-iredell-mooresville-hospital",
      "search_query": "NOVA Lake Norman close to Iredell Mooresville hospital",
      "category": "Hospital",
      "h1_title": "NOVA Lake Norman Near Iredell Mooresville Hospital",
      "h2_subtitle": "NOVA Lake Norman is conveniently close to Iredell Mooresville Hospital, making it an ideal choice for healthcare professionals and families alike.",
      "page_copy": "Located in the heart of Mooresville, NC, NOVA Lake Norman offers you the tranquility of a close-knit community with the convenience of being near major healthcare facilities. Just a short drive from Iredell Mooresville Hospital, our apartments are perfect for healthcare professionals or anyone seeking easy access to top-tier medical care.\n\nEnjoy our modern amenities, including vaulted ceilings and in-unit washers and dryers, designed to enhance your lifestyle. With scenic pool views and a selection of one, two, and three-bedroom layouts, NOVA Lake Norman provides a comfortable retreat that's just around the corner from the hospital. Discover the perfect blend of location and convenience at our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "NOVA Lake Norman Near Iredell Mooresville Hospital",
      "seo_description": "NOVA Lake Norman offers convenient living near Iredell Mooresville Hospital in Mooresville, NC, with modern amenities and a serene community vibe.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "apartments-near-lake-norman-state-park-nc",
      "search_query": "apartments near Lake Norman State Park NC",
      "category": "Park",
      "h1_title": "Apartments Near Lake Norman State Park NC",
      "h2_subtitle": "Explore apartments close to Lake Norman State Park, NC. NOVA Lake Norman offers proximity to nature and urban amenities.",
      "page_copy": "Discover the perfect balance of nature and convenience at NOVA Lake Norman, where our apartments are situated near the stunning Lake Norman State Park, NC. This prime location allows you to experience the natural beauty and recreational opportunities of the park, making it an ideal choice for outdoor enthusiasts who love hiking, biking, and water activities.\n\nOur community in Mooresville offers spacious one, two, and three-bedroom apartments designed with modern living in mind. Enjoy vaulted ceilings, in-home washers and dryers, and scenic pool views that perfectly complement the tranquil atmosphere. NOVA Lake Norman provides an excellent getaway while keeping you connected to the vibrant life of Mooresville and the serene environment of Lake Norman State Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lake Norman State Park NC",
      "seo_description": "Find beautiful apartments near Lake Norman State Park, NC at NOVA Lake Norman. Perfect for outdoor enthusiasts and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "mooresville-nc-apartments-close-to-stumpy-creek-park",
      "search_query": "Mooresville NC apartments close to Stumpy Creek Park",
      "category": "Park",
      "h1_title": "Mooresville Apartments Near Stumpy Creek Park",
      "h2_subtitle": "Discover charming Mooresville, NC apartments close to Stumpy Creek Park. Experience the best of outdoor and modern living at NOVA Lake Norman.",
      "page_copy": "Experience the ideal blend of nature's beauty and urban convenience at NOVA Lake Norman, featuring Mooresville, NC apartments close to Stumpy Creek Park. Perfect for families and nature lovers, the park offers abundant green spaces, hiking trails, and picnic areas, providing endless opportunities for leisure and outdoor activities.\n\nAt NOVA Lake Norman, choose from our variety of one, two, and three-bedroom floor plans, each designed with your comfort in mind. Enjoy vaulted ceilings, in-unit laundry, and stunning pool views, all nestled in a welcoming community. Live close to the adventure and tranquility of Stumpy Creek Park while enjoying the convenience of modern amenities right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mooresville Apartments Near Stumpy Creek Park",
      "seo_description": "Explore Mooresville, NC apartments near Stumpy Creek Park at NOVA Lake Norman. Perfect for active lifestyles and modern conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449164260",
      "source": "generator",
      "page_item_url": "apartments-near-cornelius-road-park-iredell-county",
      "search_query": "apartments near Cornelius Road Park Iredell County",
      "category": "Park",
      "h1_title": "Apartments Near Cornelius Road Park, Iredell",
      "h2_subtitle": "Explore apartments conveniently located near Cornelius Road Park in Iredell County. NOVA Lake Norman offers a perfect mix of nature and comfort.",
      "page_copy": "Nestled in the vibrant community of Mooresville, NOVA Lake Norman provides modern living spaces just minutes from Cornelius Road Park in Iredell County. This nearby park is a local treasure, offering a variety of recreational activities like sports fields, safe walking trails, and serene picnic areas, perfect for families and active individuals.\n\nOur diverse selection of one, two, and three-bedroom apartments feature vaulted ceilings, in-home washers and dryers, and beautiful pool views. Enjoy the balance of a tranquil setting with easy access to outdoor activities and the conveniences of a modern lifestyle. NOVA Lake Norman is the ideal location for those seeking both leisure and livability.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
      "featured_image_media": {
        "alt_text": "Living room with vaulted ceiling, fireplace, and view of a swimming pool.",
        "public_id": "019d0811-cc56-766a-9eab-89df614c0093",
        "storage_key": "property/6767906449164260/019d0811-cc56-766a-9eab-89df614c0093.webp",
        "width": 1536,
        "height": 1024
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cornelius Road Park, Iredell",
      "seo_description": "Find ideal apartments near Cornelius Road Park in Iredell County at NOVA Lake Norman. Perfect mix of outdoor recreation and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4473"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "7843210195"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5441558"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_y_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=y"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NPNV676Q"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_ag_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=ag"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_br_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=br"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_rp_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=rp"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_y_title",
      "type": "STRING",
      "value": "Yelp"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_zu_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=zu"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "704-286-0273"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_ag_title",
      "type": "STRING",
      "value": "Apartment Guide"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_br_title",
      "type": "STRING",
      "value": "Brochure/Flyer"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "704-270-3677"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "704-272-3239"
    },
    {
      "ID": "custom_knock_rp_title",
      "type": "STRING",
      "value": "RentPath"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "704-288-4827"
    },
    {
      "ID": "custom_knock_y_number",
      "type": "STRING",
      "value": "704-286-1880"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "704-286-8163"
    },
    {
      "ID": "custom_knock_zu_title",
      "type": "STRING",
      "value": "Zumper"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_ag_number",
      "type": "STRING",
      "value": "704-285-2440"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "704-270-6518"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "704-234-6552"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_br_number",
      "type": "STRING",
      "value": "704-251-5839"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "704-270-6523"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "704-233-7598"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "704-285-1345"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "704-237-6832"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppc2_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=ppc2"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_knock_rp_number",
      "type": "STRING",
      "value": "704-286-9559"
    },
    {
      "ID": "custom_knock_zu_number",
      "type": "STRING",
      "value": "704-228-9485"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "704-705-8386"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "704-276-6233"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "704-253-8984"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "704-270-6613"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppc2_title",
      "type": "STRING",
      "value": "PPC"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "704-601-7333"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "704-228-9316"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "704-285-0781"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_costar_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=costar"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "704-288-4774"
    },
    {
      "ID": "custom_knock_ppc2_number",
      "type": "STRING",
      "value": "704-312-7431"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "25816049449"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "704-275-6261"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "704-327-2464"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f11efe6cb1282d29"
    },
    {
      "ID": "custom_knock_costar_title",
      "type": "STRING",
      "value": "CoStar"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "704-270-5335"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_costar_number",
      "type": "STRING",
      "value": "704-800-3891"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "704-270-6606"
    },
    {
      "ID": "custom_knock_outbound_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=outbound"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "704-912-4413"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "704-286-0232"
    },
    {
      "ID": "custom_knock_outbound_title",
      "type": "STRING",
      "value": "Outbound"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "704-286-9428"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_outbound_number",
      "type": "STRING",
      "value": "704-285-0974"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "704-271-4533"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.novalakenorman.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6767906449164260/019e6465-91fc-7469-a598-457826bd6cdf.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "704-253-4877"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "704-237-6832"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "4473",
  "custom_repli_id": "7843210195",
  "custom_realpage_id": "5441558",
  "custom_knock_a_link": "https://www.novalakenorman.com?utm_knock=a",
  "custom_knock_g_link": "https://www.novalakenorman.com?utm_knock=g",
  "custom_knock_r_link": "https://www.novalakenorman.com?utm_knock=r",
  "custom_knock_w_link": "https://www.novalakenorman.com?utm_knock=w",
  "custom_knock_y_link": "https://www.novalakenorman.com?utm_knock=y",
  "custom_knock_z_link": "https://www.novalakenorman.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-NPNV676Q",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_ag_link": "https://www.novalakenorman.com?utm_knock=ag",
  "custom_knock_al_link": "https://www.novalakenorman.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.novalakenorman.com?utm_knock=ar",
  "custom_knock_br_link": "https://www.novalakenorman.com?utm_knock=br",
  "custom_knock_cl_link": "https://www.novalakenorman.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.novalakenorman.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.novalakenorman.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.novalakenorman.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_rp_link": "https://www.novalakenorman.com?utm_knock=rp",
  "custom_knock_w_title": "Property Website",
  "custom_knock_y_title": "Yelp",
  "custom_knock_z_title": "Zillow",
  "custom_knock_zu_link": "https://www.novalakenorman.com?utm_knock=zu",
  "custom_knock_a_number": "704-286-0273",
  "custom_knock_ads_link": "https://www.novalakenorman.com?utm_knock=ads",
  "custom_knock_ag_title": "Apartment Guide",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.novalakenorman.com?utm_knock=bnr",
  "custom_knock_br_title": "Brochure/Flyer",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "704-270-3677",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.novalakenorman.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.novalakenorman.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.novalakenorman.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.novalakenorman.com?utm_knock=psa",
  "custom_knock_r_number": "704-272-3239",
  "custom_knock_rp_title": "RentPath",
  "custom_knock_w_number": "704-288-4827",
  "custom_knock_y_number": "704-286-1880",
  "custom_knock_z_number": "704-286-8163",
  "custom_knock_zu_title": "Zumper",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_ag_number": "704-285-2440",
  "custom_knock_al_number": "704-270-6518",
  "custom_knock_amap_link": "https://www.novalakenorman.com?utm_knock=amap",
  "custom_knock_ar_number": "704-234-6552",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_br_number": "704-251-5839",
  "custom_knock_cl_number": "704-270-6523",
  "custom_knock_fb_number": "704-233-7598",
  "custom_knock_fl_number": "704-285-1345",
  "custom_knock_gp_number": "704-237-6832",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.novalakenorman.com?utm_knock=osoc",
  "custom_knock_ppc2_link": "https://www.novalakenorman.com?utm_knock=ppc2",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_knock_rp_number": "704-286-9559",
  "custom_knock_zu_number": "704-228-9485",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "704-705-8386",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.novalakenorman.com?utm_knock=bcard",
  "custom_knock_bnr_number": "704-276-6233",
  "custom_knock_cfres_link": "https://www.novalakenorman.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "704-253-8984",
  "custom_knock_lgp_number": "704-270-6613",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppc2_title": "PPC",
  "custom_knock_ppn_number": "704-601-7333",
  "custom_knock_psa_number": "704-228-9316",
  "custom_seo_subscription": "full_stack",
  "custom_knock_amap_number": "704-285-0781",
  "custom_knock_bandit_link": "https://www.novalakenorman.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_costar_link": "https://www.novalakenorman.com?utm_knock=costar",
  "custom_knock_flyers_link": "https://www.novalakenorman.com?utm_knock=flyers",
  "custom_knock_osoc_number": "704-288-4774",
  "custom_knock_ppc2_number": "704-312-7431",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "25816049449",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "704-275-6261",
  "custom_knock_cfres_number": "704-327-2464",
  "custom_knock_chatgpt_link": "https://www.novalakenorman.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "f11efe6cb1282d29",
  "custom_knock_costar_title": "CoStar",
  "custom_knock_dirmail_link": "https://www.novalakenorman.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_propbro_link": "https://www.novalakenorman.com?utm_knock=propbro",
  "custom_knock_bandit_number": "704-270-5335",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_costar_number": "704-800-3891",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "704-270-6606",
  "custom_knock_outbound_link": "https://www.novalakenorman.com?utm_knock=outbound",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.novalakenorman.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "704-912-4413",
  "custom_knock_dirmail_number": "704-286-0232",
  "custom_knock_outbound_title": "Outbound",
  "custom_knock_propbro_number": "704-286-9428",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_outbound_number": "704-285-0974",
  "custom_knock_revcards_number": "704-271-4533",
  "custom_knock_maintenance_link": "https://www.novalakenorman.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6767906449164260/019e6465-91fc-7469-a598-457826bd6cdf.mp4",
  "custom_knock_maintenance_number": "704-253-4877",
  "custom_ppc_tracking_phone_number": "704-237-6832"
};

export const generatedAt = '2026-10-07T17:11:33.046Z';
